import type { TranslationDictionary } from '@eliadmin/core/src/i18n/translation-snapshot-types';

export const GENERATED_TRANSLATIONS = Object.freeze({
  "text1": "Search",
  "text2": "Your order",
  "text3": "Your order",
  "text4": "Hello",
  "text5": "To place an order",
  "text6": "we expect payment by bank transfer.",
  "text7": "Order delivered",
  "text8": "Your order has been successfully delivered.",
  "text9": "Parameters",
  "text10": "Facebook",
  "text11": "Order shipped",
  "text12": "is on its way to you.",
  "text13": "You can track the detailed movement of your parcel by clicking on the parcel number.",
  "text14": "Shipment tracking number:",
  "text15": "Thank you for your purchase",
  "text16": "We register your order under the tracking number",
  "text17": "Order detail",
  "text18": "Created:",
  "text19": "Code",
  "text20": "Product",
  "text21": "Unit price",
  "text22": "Quantity",
  "text23": "Total price",
  "text24": "Discount",
  "text25": "Discounts",
  "text26": "Total Amount",
  "text27": "Payment details",
  "text28": "IBAN",
  "text29": "Financial institution",
  "text30": "Amount",
  "text31": "Variable symbol",
  "text32": "Delivery address",
  "text33": "Name",
  "text34": "Last name",
  "text35": "E-mail",
  "text36": "Phone",
  "text37": "Business name",
  "text38": "Street",
  "text39": "City",
  "text40": "ZIP CODE",
  "text41": "Country",
  "text42": "ID",
  "text43": "TAX ID",
  "text44": "VAT",
  "text45": "Billing address",
  "text46": "Order cancelled",
  "text47": "has been cancelled.",
  "text48": "Payment received",
  "text49": "has been paid.",
  "text50": "Order status can also be monitored by logging into the user account.",
  "text51": "Login to my account",
  "text52": "Returned order",
  "text53": "has been returned",
  "text54": "Refund",
  "text55": "For an order",
  "text56": "Your money has been refunded.",
  "text57": "Note",
  "text58": "Shipping cost",
  "text59": "Price of payment",
  "text60": "Similar products",
  "text61": "Popular products",
  "text62": "Order received",
  "text63": "Order",
  "text64": "VAT",
  "text65": "No.",
  "text66": "is on its way to you.",
  "text67": "Registration successful",
  "text68": "Your registration has been successful.",
  "text69": "Password generated:",
  "text70": "We recommend changing your password after logging in.",
  "text71": "You can log in to your account in the",
  "text72": "User account",
  "text73": "or by clicking on the login button.",
  "text74": "Login to my account",
  "text75": "MY EMAIL:",
  "text76": "LINK TO CHEAPER PRODUCT:",
  "text77": "LINK TO YOUR PRODUCT:",
  "text78": "Happy Birthday.",
  "text79": "LINK TO PRODUCT:",
  "text80": "Message:",
  "text81": "Subject",
  "text82": "Contact form",
  "text83": "As a token of our confidence, we are sending you a discount coupon",
  "text84": "in the amount of",
  "text85": "The validity of the coupon is from",
  "text86": "to",
  "text87": "Newsletter",
  "text88": "Click on the button below to confirm your subscription to the newsletter.",
  "text89": "Confirm newsletter subscription",
  "text90": "Confirm items",
  "text91": "We have accepted your return. Thank you very much. The money is on its way to you. The method of refund will depend on the payment method you chose in your order.",
  "text92": "If your product information that you have reported from your user accounts, different from the returned products, then we reserve the right to re-bill your credit card for the amount already paid.",
  "text93": "Please note that each returned package is processed separately. If you have sent additional products in a different package, you will receive a separate receipt.",
  "text94": "Returned Products:",
  "text95": "Click the button below to reset your password.",
  "text96": "Reset password",
  "text97": "Order payment was incorrect",
  "text98": "You can repeat your payment",
  "text99": "Click on this link to be redirected to the payment gateway.",
  "text100": "Thank you for your order",
  "text101": "Question",
  "text102": "Product inquiry:",
  "text103": "Return request",
  "text104": "We have received your request for a refund. You can start preparing your package.",
  "text105": "We will refund your money as soon as we receive the returned goods, but no later than 14 days.",
  "text106": "Did you order goods with prepayment? If you have not yet paid for the goods, we will adjust the amount to be paid to exclude your return.",
  "text107": "Returns:",
  "text108": "Order number",
  "text109": "Your claim has been cancelled",
  "text110": "Your claim has not been approved",
  "text111": "Reason",
  "text112": "We are processing your claim",
  "text113": "Issued by",
  "text114": "Page 1/1",
  "text115": "Change password",
  "text116": "Invoice",
  "text117": "Supplier",
  "text118": "Operation",
  "text119": "Buyer",
  "text120": "Phone",
  "text121": "Date of issue",
  "text122": "Date of delivery",
  "text123": "Due date",
  "text124": "Method of payment",
  "text125": "Shipping",
  "text126": "SWIFT",
  "text127": "Payment fees",
  "text128": "Item/Code",
  "text129": "Basic price / discount",
  "text130": "VAT rate",
  "text131": "Number",
  "text132": "Total with VAT",
  "text133": "Price incl. VAT",
  "text134": "Shipping charges",
  "text135": "Tax receipt for the payment received.",
  "text136": "Total excluding VAT",
  "text137": "Total VAT",
  "text138": "Total",
  "text139": "Constant symbol",
  "text140": "Amount to be refunded",
  "text141": "Credit note",
  "text142": "to invoice",
  "text143": "Delivery note",
  "text144": "Delivery note no.",
  "text145": "Sold by",
  "text146": "Received by",
  "text147": "Date",
  "text148": "VAT Details (GBP)",
  "text149": "VAT rate",
  "text150": "Products",
  "text151": "Invoice no.",
  "text152": "Details (GBP)",
  "text153": "Shipping",
  "text154": "Orders",
  "text155": "Order no.",
  "text156": "Customer",
  "text157": "Address",
  "text158": "Payment",
  "text159": "Advance invoice no.",
  "text160": "Home",
  "text161": "Blog",
  "text162": "Search term...",
  "text163": "Shopping Cart",
  "text164": "Price",
  "text165": "Total",
  "text166": "Shopping Cart Update",
  "text167": "Discount Coupon",
  "text168": "Send order",
  "text169": "Order Summary",
  "text170": "Product Price",
  "text171": "Shopping cart is empty",
  "text172": "Shop",
  "text173": "Products",
  "text174": "Filter",
  "text175": "Manufacturer",
  "text176": "Category",
  "text177": "Cheapest",
  "text178": "Most expensive",
  "text179": "Latest",
  "text180": "Oldest",
  "text181": "Best Sellers",
  "text182": "Subscribe",
  "text183": "Your email address",
  "text184": "Register for our Newsletter now and benefit from exclusive advantages!",
  "text185": "Send",
  "text186": "Contact",
  "text187": "Change Password",
  "text188": "Forgot your password?",
  "text189": "Log in",
  "text190": "Login",
  "text191": "Password",
  "text192": "Register",
  "text193": "Don't have an account yet?",
  "text194": "Oops... the page you are looking for does not exist.",
  "text195": "Manufacturers",
  "text196": "View more products",
  "text197": "My account",
  "text198": "Personal details",
  "text199": "Company details",
  "text200": "Company",
  "text201": "Save",
  "text202": "Old password",
  "text203": "New password",
  "text204": "Change password",
  "text205": "Full article",
  "text206": "Your order has been accepted, unfortunately the payment was not successful. Please check your email for more information on the status of your order.",
  "text207": "Pay order",
  "text208": "Continue shopping",
  "text209": "You might be interested in",
  "text210": "Buy",
  "text211": "Search",
  "text212": "Item(s)",
  "text213": "Search",
  "text214": "Next day delivery",
  "text215": "Within the Czech Republic",
  "text216": "Free Gift",
  "text217": "With every order",
  "text218": "Delivery guarantee",
  "text219": "undamaged goods",
  "text220": "300 delivery points",
  "text221": "in Slovakia and the Czech Republic",
  "text222": "Latest products",
  "text223": "Top products",
  "text224": "Top articles",
  "text225": "Price with VAT",
  "text226": "Price without VAT",
  "text227": "Add to cart",
  "text228": "Product code:",
  "text229": "Share",
  "text230": "Category:",
  "text231": "Product description",
  "text232": "Accessories",
  "text233": "Additional information",
  "text234": "Newsletter you already subscribe to",
  "text235": "Continue shopping",
  "text236": "You have successfully subscribed to our newsletter",
  "text237": "Availability:",
  "text238": "In Stock",
  "text239": "To order",
  "text240": "About us",
  "text241": "Filter",
  "text242": "Products",
  "text243": "Sort by:",
  "text244": "Reset filter",
  "text245": "Order Status",
  "text246": "Back",
  "text247": "Size:",
  "text248": "Pcs",
  "text249": "GBP",
  "text250": "Change avatar",
  "text251": "You have successfully logged in",
  "text252": "Male",
  "text253": "Female",
  "text254": "Other",
  "text255": "Gender",
  "text256": "Hi",
  "text257": "My orders",
  "text258": "Sign out",
  "text259": "Enter your email",
  "text260": "Permanent login",
  "text261": "Register",
  "text262": "Register a new account",
  "text263": "Repeat password",
  "text264": "I agree with",
  "text265": "terms and conditions",
  "text266": "I already have an account and want to log in",
  "text267": "Information about cookies",
  "text268": "By clicking on the I agree to everything button, technical, analytical and marketing cookies are stored to enable us to provide you with a comfortable use of the site, measure the functionality of our site and target advertising to you. You can easily adjust your preferences by clicking on Cookie Settings.",
  "text269": "I agree to everything",
  "text270": "Cookie settings",
  "text271": "Save settings",
  "text272": "Close",
  "text273": "Cookies",
  "text274": "Description",
  "text275": "We use cookies",
  "text276": "We use cookies to analyse data about our visitors, to improve our website, to display personalised content and to give you a great web experience. By using this website, you consent to this use.",
  "text277": "Technical cookies",
  "text278": "These cookies are necessary for the functioning of the website and cannot be disabled. They are usually set in response to an action you take on the website, such as setting security, logging in and filling in forms. You can set your browser to block cookies or send notifications about them. Keep in mind that some sites will not function without these files. These cookies do not store any information that can be attributed to a specific person. These cookies may be set by us or by third party providers whose services we use on the site. These cookies do not store any information that can be attributed to a specific person.",
  "text279": "Your cookie settings from this dialog",
  "text280": "Analytical cookies",
  "text281": "These cookies are used to improve the functioning of the website. They allow us to recognise and track the number of visitors and monitor how visitors use the site. They help us to improve the way the website works, for example by enabling users to easily find what they are looking for. These cookies do not collect information that could identify you. We use these tools to analyse and regularly improve the functionality of our website. We may use the statistics we gather to improve the user experience and make your visit to the Site more interesting for you as a user.",
  "text282": "Google Analytics - stores and counts the number of page views and site behaviour",
  "text283": "Google Tag Manager - linking conversions",
  "text284": "Incomaker - stores and counts page views and conversions",
  "text285": "Marketing cookies",
  "text286": "These are used to track a user's website preferences for the purpose of targeting advertising, i.e. displaying marketing and advertising messages (including on third party sites) that may be of interest to the website visitor, in line with these preferences. Marketing cookies use tools from external companies. These marketing cookies will only be used with your consent.",
  "text287": "Facebook Pixel - displaying ads and transmitting information to Facebook",
  "text288": "Upload",
  "text289": "Exchange of goods",
  "text290": "Refunds",
  "text291": "Customer details",
  "text292": "Invoice number",
  "text293": "Bank details",
  "text294": "IBAN",
  "text295": "SWIFT",
  "text296": "Reason for refund",
  "text297": "Select the item from the list you want to return",
  "text298": "E-shop",
  "text299": "Store",
  "text300": "E-shop + Store",
  "text301": "We have received your request for a refund. You can start preparing your package.",
  "text302": "We will refund your money immediately upon receipt of your returned goods, within 14 days at the latest.",
  "text303": "Did you order goods with prepayment? If you have not yet paid for the goods, we will adjust the amount to be paid to exclude your return.",
  "text304": "Returns:",
  "text305": "Order number:",
  "text306": "We have accepted your return. Thank you very much. The money is on its way to you. The method of refund will depend on the payment method you chose for your order.",
  "text307": "If the product details you have reported from your user account differ from the returned products, then we reserve the right to recharge your credit card for the amount already paid.",
  "text308": "Please note that each returned package is processed separately. If you have sent additional products in a different package, you will receive a separate receipt.",
  "text309": "Returned Products:",
  "text310": "New",
  "text311": "Approved",
  "text312": "Rejected",
  "text313": "Cancelled",
  "text314": "In process",
  "text315": "Request for refund",
  "text316": "Confirmation of items",
  "text317": "Your claim has been cancelled",
  "text318": "We are processing your claim",
  "text319": "Your claim has not been approved",
  "text320": "Your request has not been processed",
  "text321": "Newsletter",
  "text322": "/exchange-and-return-of-goods",
  "text323": "Exchange and return of goods",
  "text324": "Company details",
  "text325": "Domain of your shop",
  "text326": "Add another domain",
  "text327": "More domains",
  "text328": "Company Name",
  "text329": "Add a business address",
  "text330": "Business address",
  "text331": "Store Name",
  "text332": "Login name",
  "text333": "Attachments",
  "text334": "Certificate from the commercial register",
  "text335": "Select attachment",
  "text336": "I agree to the terms and conditions",
  "text337": "Subcategories",
  "text338": "Show more",
  "text339": "Availability",
  "text340": "Price",
  "text341": "Filter by",
  "text342": "Your selected product has been added to cart.",
  "text343": "Cart",
  "text344": "Price payment",
  "text345": "Shipping price",
  "text346": "Select shipping method",
  "text347": "Coupon number",
  "text348": "Select payment method",
  "text349": "Free",
  "text350": "Order Summary",
  "text351": "Price of goods",
  "text352": "Order has been shipped",
  "text353": "Your order no.",
  "text354": "has been recorded and is currently being processed. Please check your email",
  "text355": "for more information about your order",
  "text356": "Confirm password",
  "text357": "Log in",
  "text358": "Do you have an account?",
  "text359": "Delivery details",
  "text360": "Contact details",
  "text361": "Purchase to company",
  "text362": "Create an account and enjoy the benefits of being a registered customer.",
  "text363": "I agree to the terms and conditions.",
  "text364": "I agree to the privacy policy.",
  "text365": "Delivery address is different from the billing address",
  "text366": "Dropshipping",
  "text367": "Operating address",
  "text368": "Personal data settings",
  "text369": "Change delivery address",
  "text370": "Continue to checkout",
  "text371": "Subscribe to our newsletter and receive updates on promotions",
  "text372": "Return items",
  "text373": "Returned items",
  "text374": "What would you like to return?",
  "text375": "You have not ordered anything in the last 30 days.",
  "text376": "Confirm product returns",
  "text377": "Cancel",
  "text378": "my-account-returned-goods",
  "text379": "my-account-return-1",
  "text380": "my-account-return-2",
  "text381": "my-account-return-3",
  "text382": "Slovakia",
  "text383": "Czech Republic",
  "text384": "Hungary",
  "text385": "Login details",
  "text386": "Read more",
  "text387": "In your basket",
  "text388": "To recover a forgotten password, enter your email",
  "text389": "Date of birth",
  "text390": "Use",
  "text391": "/general-business-conditions",
  "text392": "/protection-of-personal-agencies",
  "text393": "Date of order",
  "text394": "Order number",
  "text395": "Select reason",
  "text396": "The goods do not match the description",
  "text397": "I received the wrong product",
  "text398": "I don't like this item",
  "text399": "The item is too large",
  "text400": "The item is damaged",
  "text401": "Product arrived late",
  "text402": "Product is too small",
  "text403": "Product is too expensive",
  "text404": "No details",
  "text405": "Return to",
  "text406": "Company item(s)",
  "text407": "Items you are returning to the company",
  "text408": "We have sent you a list of the products you have returned to",
  "text409": "Your products are ready for return",
  "text410": "What next?",
  "text411": "Prepare your package",
  "text412": "Now you just need to send the package",
  "text413": "Get your money back",
  "text414": "Pack the products you want, include a return label and a return address will arrive on the parcel. And did you know that you can return items that came in several packages together in one package? Simply pack the return labels from each order",
  "text415": "Take the parcel to the nearest logistics centre you selected on the form",
  "text416": "We will refund your money immediately upon receipt of your returned goods, no later than 14 days afterwards. Did you order goods with prepayment? If you have not yet paid for the goods, we will adjust the amount to be paid so that it does not include your return",
  "text417": "Number of products",
  "text418": "Return to company",
  "text419": "Status",
  "text420": "Created on",
  "text421": "You have no returned items.",
  "text422": "Please set your IBAN and SWIFT in your account settings.",
  "text423": "You have no bank details set",
  "text424": "Buy more for",
  "text425": "and you have shipping",
  "text426": "FREE",
  "text427": "Congratulations, you have shipping",
  "text428": "Your message has been successfully sent!",
  "text429": "Error, your message has not been sent!",
  "text430": "",
  "text431": "Email exists; please use a different one.",
  "text432": "Registration successful.",
  "text433": "Variant code",
  "text434": "my-account-return-1",
  "text435": "Sales unit",
  "text436": "privacy policy",
  "text437": "Labels",
  "text438": "Street number",
  "text439": "Loading",
  "text440": "Select a subscription point",
  "text441": "Select variant",
  "text442": "Add to favorites",
  "text443": "without VAT",
  "text444": "Price is approximate",
  "text445": "No results",
  "text446": "Ask about a product",
  "text447": "Reviews",
  "text448": "Additional services",
  "text449": "Packages",
  "text450": "To send",
  "text451": "Video",
  "text452": "Full description",
  "text453": "Sorry, we only have a limited amount of this product in stock",
  "text454": "you can no longer add items to the cart.",
  "text455": "OK",
  "text456": "Go to cart",
  "text457": "",
  "text458": "Your shopping cart is waiting for you",
  "text459": "You did not complete your order on your last visit. The goods you have chosen are waiting for you in your basket. Don't miss it and complete your purchase now.",
  "text460": "Your order has been successfully received. Please check your email inbox.",
  "text461": "Your message has been successfully sent!",
  "text462": "Email is mandatory.",
  "text463": "The entered email address is not valid.",
  "text464": "Email can have a maximum of 255 characters.",
  "text465": "The entered email is already registered.",
  "text466": "The password is mandatory.",
  "text467": "Password must have at least 6 characters.",
  "text468": "Passwords do not match.",
  "text469": "Consent to the terms and conditions is a mandatory requirement.",
  "text470": "Check the captcha form.",
  "text471": "Go to the online help",
  "text472": "View question and answer topics",
  "text473": "Hide question and answer topics",
  "text474": "Go to the blog",
  "text475": "Counselling room",
  "text476": "Ask our pharmacist directly",
  "text477": "No options",
  "text478": "Select categories",
  "text479": "for orders over",
  "text480": "Back to the shop",
  "text481": "Price / pcs incl. VAT",
  "text482": "Total price",
  "text483": "Price / pcs without VAT",
  "text484": "",
  "text485": "House number",
  "text486": "Profile",
  "text487": "Change details",
  "text488": "Security",
  "text489": "Change place",
  "text490": "Load next",
  "text491": "My details",
  "text492": "Follow us",
  "text493": "Bestsellers",
  "text494": "All products",
  "text495": "Unavailable",
  "text496": "Choose a variant",
  "text497": "",
  "text498": "",
  "text499": "",
  "text500": "",
  "text501": "",
  "text502": "Full name",
  "text503": "Confirm the new password",
  "text504": "Please confirm your agreement to the terms of personal data protection.",
  "text505": "The entered e-mail address is already subscribed to receive news.",
  "text506": "Please check your email inbox.",
  "text507": "Delivery point",
  "text508": "Ask about a product",
  "text509": "Question about the availability of goods",
  "text510": "Special offer",
  "text511": "Width",
  "text512": "Length",
  "text513": "Height",
  "text514": "Weight",
  "text515": "Rated on",
  "text516": "Favorites",
  "text517": "Return back to homepage",
  "text518": "Product status",
  "text519": "Country",
  "text520": "Delivery and billing address",
  "text521": "Already have an account?",
  "text522": "Back to cart",
  "text523": "Discount coupon",
  "text524": "Add to order",
  "text525": "Shopping cart content",
  "text526": "Continue to order",
  "text527": "Share product",
  "text528": "Hide description",
  "text529": "Full description",
  "text530": "There's been an error, try again in a minute.",
  "text531": "Add to favorites",
  "text532": "Remove from favorites",
  "text533": "Detail",
  "text534": "New reservation",
  "text535": "Reservation successfully created",
  "text536": "Payment discount",
  "text537": "Unsubscribe",
  "text538": "Choose a term",
  "text539": "Subscribing point",
  "text540": "Deadline",
  "text541": "Discount for customer",
  "text542": "Summary dispatched order no.",
  "text543": "Order no.",
  "text544": "Not logged in user",
  "text545": "Coupon is valid",
  "text546": "The coupon does not exist, has expired or the conditions for applying the coupon are not met",
  "text547": "Coupon is invalid",
  "text548": "Coupon has been added",
  "text549": "Answer",
  "text550": "He answered the question",
  "text551": "Ask a question",
  "text552": "Name",
  "text553": "You must be logged in to post your own question in the advice section",
  "text554": "We found no matching records",
  "text555": "Today is her name day",
  "text556": "Notice",
  "text557": "Incorrect login details",
  "text558": "The original password does not match",
  "text559": "Interest in work",
  "text560": "New applicant",
  "text561": "Thank you for your order, which we will start processing as soon as it is paid.",
  "text562": "Payment successful.",
  "text563": "Payment unsuccessful.",
  "text564": "Captcha authentication failed.",
  "text565": "No parameters",
  "text566": "Product filter",
  "text567": "I need advice",
  "text568": "Contact and support",
  "text569": "Send us message",
  "text570": "Follow us on social media",
  "text571": "Shipping and payment",
  "text572": "Loyalty programme",
  "text573": "An error occurred when signing up for the newsletter",
  "text574": "Subscribe to newsletters by email",
  "text575": "Do you want to be among the first to be informed about promotions and discounts? Just enter your email address.",
  "text576": "Thank you for subscribing to our newsletter. A confirmation of your subscription has been sent to your e-mail address.",
  "text577": "Articles",
  "text578": "Online chat",
  "text579": "Online counselling",
  "text580": "Product consultancy",
  "text581": "Frequently Asked Questions",
  "text582": "Personal pickup",
  "text583": "News",
  "text584": "Promotions",
  "text585": "Write a review",
  "text586": "Review",
  "text587": "Rating",
  "text588": "View more articles",
  "text589": "Topics",
  "text590": "Search article",
  "text591": "Read the full article",
  "text592": "Published by",
  "text593": "You must be logged in to write a review.",
  "text594": "Something went wrong",
  "text595": "Try again",
  "text596": "Hide answer",
  "text597": "Show answer",
  "text598": "Popular articles",
  "text599": "Filter categories",
  "text600": "Back to the blogs page",
  "text601": "Find your dream job!",
  "text602": "Country of delivery",
  "text603": "You can change the country of delivery in the previous step",
  "text604": "Show less",
  "text605": "",
  "text606": "maximum",
  "text607": "We have selected for you",
  "text608": "No reviews",
  "text609": "I want to receive emails with news about current trends, promotions and discount coupons. You can unsubscribe for free at any time.",
  "text610": "Newsletter subscription",
  "text611": "Need advice?",
  "text612": "Contact us",
  "text613": "I agree to the",
  "text614": "processing of personal data",
  "text615": "Message",
  "text616": "Business data",
  "text617": "Data on operation",
  "text618": "Trade register",
  "text619": "Name of bank",
  "text620": "If you haven't shopped with us before and don't have an account,",
  "text621": "create one here",
  "text622": "I forgot my password",
  "text623": "Already have an account?",
  "text624": "Log in.",
  "text625": "By registering an account, you agree to our",
  "text626": "terms of use.",
  "text627": "Read our",
  "text628": "Privacy Policy",
  "text629": "Yes, I want to receive occasional emails with special offers. I can cancel my subscription at any time. (Optional)",
  "text630": "The password must contain at least 8 characters.",
  "text631": "Added to cart",
  "text632": "Clear",
  "text633": "All blogs",
  "text634": "Show results",
  "text635": "Write a question",
  "text636": "View the answer from a specialist",
  "text637": "There are no questions in this category yet",
  "text638": "Back to the main page",
  "text639": "Project created",
  "text640": "All rights reserved",
  "text641": "Shipping and payment method",
  "text642": "Your question will be displayed once it has been approved by an administrator",
  "text643": "Thank you",
  "text644": "or write to",
  "text645": "Use discount code",
  "text646": "Coupon code",
  "text647": "Redeem discount code",
  "text648": "Review has been added",
  "text649": "Password has been successfully changed",
  "text650": "Failed to change password",
  "text651": "Password reset error occurred",
  "text652": "You have received a password reset email",
  "text653": "An error occurred during registration",
  "text654": "You have successfully registered",
  "text655": "An error occurred when logging in",
  "text656": "You were logged in",
  "text657": "There was an error when submitting the contact form",
  "text658": "Contact form has been successfully submitted",
  "text659": "Your question has been sent successfully",
  "text660": "There was an error when submitting the question",
  "text661": "There was an error while creating the review",
  "text662": "Price / pcs",
  "text663": "Total",
  "text664": "Gift",
  "text665": "Follow us on instagram",
  "text666": "View instagram",
  "text667": "The colour is in the wrong format.",
  "text668": "more...",
  "text669": "Buy",
  "text670": "View all products",
  "text671": "Blogs",
  "text672": "No labels",
  "text673": "No blogs",
  "text674": "No categories",
  "text675": "Subtotal",
  "text676": "Have you shopped with us before?",
  "text677": "If you've already shopped with us, log in to your account to automatically add your order details and speed up the checkout process.",
  "text678": "I am a new customer",
  "text679": "Invoicing data",
  "text680": "Damaged product",
  "text681": "Inappropriate gift",
  "text682": "I don't want to state",
  "text683": "Select a reason",
  "text684": "Courier",
  "text685": "Returned products:",
  "text686": "Cancel refund",
  "text687": "Confirm product return",
  "text688": "Company address",
  "text689": "Company data",
  "text690": "Opening hours",
  "text691": "Check availability",
  "text692": "E-prescription",
  "text693": "E-prescription booking",
  "text694": "Loyalty card",
  "text695": "I want a card",
  "text696": "I have a card",
  "text697": "Birth number",
  "text698": "Telephone is essential for informing the status of the reservation",
  "text699": "We need your personal identification number to verify your prescription",
  "text700": "Send recipe reservation",
  "text701": "Select a city",
  "text702": "Loyalty card number",
  "text703": "Product name",
  "text704": "Enter product name/barcode number",
  "text705": "Search by name or barcode - digits below the product barcode",
  "text706": "Customized product",
  "text707": "Write a dedication...",
  "text708": "Select a delivery date",
  "text709": "View more subcategories",
  "text710": "Hide subcategories",
  "text711": "I have a paper recipe",
  "text712": "Set both IBAN and SWIFT in your account settings",
  "text713": "We have successfully registered the return",
  "text714": "Returned orders",
  "text715": "Return of goods",
  "text716": "Date of return",
  "text717": "Download",
  "text718": "Suppliers",
  "text719": "Product information",
  "text720": "Product price",
  "text721": "Go to shop",
  "text722": "Changing the status of a claim",
  "text723": "It can only contain a format with a maximum of 4 numbers before the decimal point and 8 after the decimal point.",
  "text724": "Where everywhere we've been",
  "text725": "Continue to main page",
  "text726": "Enter order number and email",
  "text727": "Link",
  "text728": "Supplier location",
  "text729": "Minimum number of characters is",
  "text730": "Maximum number of characters is",
  "text731": "This field can't be empty",
  "text732": "Email address must be valid",
  "text733": "The phone number must be valid",
  "text734": "Required",
  "text735": "Date must be valid",
  "text736": "Input must be a number",
  "text737": "Input must be an integer",
  "text738": "Input must be a decimal number",
  "text739": "Passwords don't match",
  "text740": "You must agree to GDPR",
  "text741": "You must agree to the terms of use",
  "text742": "You must select at least one product",
  "text743": "Fill in your benefit card details or your name",
  "text744": "Related products",
  "text745": "Logged as",
  "text746": "Search",
  "text747": "Keyword",
  "text748": "Distance",
  "text749": "Category",
  "text750": "Required fields",
  "text751": "Contact us at any time if you have some special request or if you have some questions.",
  "text752": "No results",
  "text753": "Selected days are unavailable",
  "text754": "Edit",
  "text755": "Delete account",
  "text756": "Business",
  "text757": "In case we need to contact you about your order.",
  "text758": "Create account",
  "text759": "No suppliers are located within the selected distance",
  "text760": "Select a supplier",
  "text761": "Select a city",
  "text762": "Fill your billing address so you don’t have to do it with every order.",
  "text763": "You must be logged in to complete the wholesale form.",
  "text764": "Wholesale",
  "text765": "Congratulations! You are already registered as a wholesaler.",
  "text766": "Type of company and domains",
  "text767": "Contact information",
  "text768": "Maximum file size 2MB",
  "text769": "Dropshipping",
  "text770": "Order for stock",
  "text771": "Dropship delivery address",
  "text772": "Personal and contact details",
  "text773": "Delivery address",
  "text774": "Your form has been submitted successfully. We will contact you as soon as possible regarding wholesale terms.",
  "text775": "Enable location retrieval",
  "text776": "It is necessary to select a delivery date",
  "text777": "A specific dispensing point needs to be selected",
  "text778": "The package price is higher than the allowed value.",
  "text779": "The package includes",
  "text780": "The package does not have a maximum price",
  "text781": "Enter your postcode",
  "text782": "Enter City",
  "text783": "Calculate the price",
  "text784": "Send to the shelter",
  "text785": "Brand",
  "text786": "Question for the pharmacist",
  "text787": "She answered the question",
  "text788": "Job offers",
  "text789": "Online counselling",
  "text790": "Hide question and answer topics",
  "text791": "View question and answer topics",
  "text792": "Find out more",
  "text793": "Show all offers",
  "text794": "Offer detail",
  "text795": "Place of work",
  "text796": "Gross wage",
  "text797": "Employment type",
  "text798": "Onset",
  "text799": "More references",
  "text800": "Call us",
  "text801": "We are available",
  "text802": "About company",
  "text803": "Contact information",
  "text804": "Order documents",
  "text805": "No documents available for this order",
  "text806": "Choose a shelter",
  "text807": "See detail",
  "text808": "I am interested in implementation",
  "text809": "out of",
  "text810": "offers",
  "text811": "from",
  "text812": "in gross",
  "text813": "I'm interested in a job",
  "text814": "Upload CV",
  "text815": "Send interest",
  "text816": "Instalment Calculator",
  "text817": "View the offer",
  "text818": "Configurator",
  "text819": "All realizations",
  "text820": "Where to find us",
  "text821": "Sales department",
  "text822": "Sales representatives",
  "text823": "Legal note",
  "text824": "See technical parameters",
  "text825": "Please select the place of delivery",
  "text826": "Variants",
  "text827": "Name day has",
  "text828": "For download",
  "text829": "Find a job",
  "text830": "Popular categories",
  "text831": "Find the type of work that suits you! Work starts immediately after purchase and requirements are provided.",
  "text832": "open positions",
  "text833": "Create a CV",
  "text834": "Create your profile and find thousands of jobs, build your career and\n  employment!",
  "text835": "Latest job offers",
  "text836": "Find the type of work that suits you! Work starts immediately after purchase and requirements are provided.",
  "text837": "Send CV",
  "text838": "/ monthly",
  "text839": "It is necessary to choose a shelter",
  "text840": "Shelters you can support with us",
  "text841": "I am over 18 years old",
  "text842": "The content of this site is not suitable for persons",
  "text843": "under 18 years of age.",
  "text844": "All",
  "text845": "Only new",
  "text846": "Only used",
  "text847": "Type",
  "text848": "Year",
  "text849": "Model",
  "text850": "My CV",
  "text851": "CV preview",
  "text852": "Account deletion",
  "text853": "Once your account has been deleted, your data cannot be recovered.",
  "text854": "Delete account",
  "text855": "Settings",
  "text856": "I am interested in receiving job offers by e-mail",
  "text857": "Preferred language",
  "text858": "Go to all job offers",
  "text859": "Curriculum Vitae",
  "text860": "Step",
  "text861": "Basic data",
  "text862": "Photography",
  "text863": "Work experience",
  "text864": "Education",
  "text865": "Knowledge",
  "text866": "Languages",
  "text867": "Additional parts",
  "text868": "Final settings",
  "text869": "Search by keyword, company name",
  "text870": "Municipality, district, region",
  "text871": "Retrieved from",
  "text872": "Street and number",
  "text873": "Upload your photo",
  "text874": "A photo is not compulsory, but a CV with a photo is more personal and will attract the recruiter's attention\n  more.",
  "text875": "Did you know that it takes an average of 7 seconds for a recruiter to scan a CV for the first time? So only mention relevant experiences and describe them in bullet points or short paragraphs.",
  "text876": "Position title, company",
  "text877": "City or postcode",
  "text878": "What is your educational background?",
  "text879": "Let employers know what your educational background is",
  "text880": "Add education",
  "text881": "Job offer",
  "text882": "Active offers",
  "text883": "Focus",
  "text884": "College",
  "text885": "Secondary school",
  "text886": "Course or certificate",
  "text887": "I am interested in a job",
  "text888": "Your skills and knowledge",
  "text889": "Enter what skills and knowledge you have and at what level.",
  "text890": "Profession",
  "text891": "The language you speak",
  "text892": "Indicate the academic degree next to the name",
  "text893": "Salary",
  "text894": "Type of employment",
  "text895": "Responding to a job offer",
  "text896": "Information on the profession",
  "text897": "I am self-employed",
  "text898": "Optional attachments",
  "text899": "CV, Cover letter, Statements, certificates, other... (max. 10MB)",
  "text900": "The language you speak",
  "text901": "Select language",
  "text902": "Title",
  "text903": "Country",
  "text904": "Select a country",
  "text905": "Select a region",
  "text906": "Maximum file size is 10MB",
  "text907": "Add attachment",
  "text908": "Number of attachments",
  "text909": "Driving licence",
  "text910": "What driving licences do you have?",
  "text911": "How do you like to fill your free time?",
  "text912": "Interests or hobbies",
  "text913": "Briefly and concisely describe how you like to spend your free time.",
  "text914": "Your CV is ready. Add the following information to help you in your job search on pracaslovensko.sk",
  "text915": "Job position",
  "text916": "In what field or in what specific position would you like to work?",
  "text917": "Work area",
  "text918": "Select a work area",
  "text919": "Place of work",
  "text920": "In what location are you looking for a job?",
  "text921": "Type of employment",
  "text922": "Please indicate which type of working hours would suit you",
  "text923": "Date of arrival",
  "text924": "Please indicate the date of possible arrival",
  "text925": "Expected minimum salary (gross)",
  "text926": "Please indicate your idea of the minimum salary (gross).",
  "text927": "Preferred working shifts",
  "text928": "Please indicate your preferences for working shifts",
  "text929": "Health disadvantage",
  "text930": "Are you disadvantaged at work?",
  "text931": "Job offers by email?",
  "text932": "Would you like us to send you suitable job offers by email?",
  "text933": "City/County",
  "text934": "Immediately",
  "text935": "By agreement",
  "text936": "Amount from (EUR)",
  "text937": "Am I also interested in a job where I would work on weekends",
  "text938": "I am also interested in working at night",
  "text939": "I have a work-related disability",
  "text940": "41% - 70%",
  "text941": "More than 70%",
  "text942": "Additional information",
  "text943": "I am interested in receiving job offers by e-mail",
  "text944": "Personal summary",
  "text945": "Write a short summary about yourself in 2-3 sentences.",
  "text946": "Additional information",
  "text947": "Is there anything else you want to add? Write it here.",
  "text948": "Insert files or move here",
  "text949": "PNG, JPG, GIF",
  "text950": "Select file",
  "text951": "Add a job",
  "text952": "Time lapse",
  "text953": "Job Description",
  "text954": "Briefly and concisely describe your job description.",
  "text955": "Adding a job",
  "text956": "Job title",
  "text957": "Employer",
  "text958": "City/municipality",
  "text959": "Landscape",
  "text960": "Time period",
  "text961": "I currently work here",
  "text962": "From the month",
  "text963": "Since",
  "text964": "Within a month",
  "text965": "By the year",
  "text966": "Job Description",
  "text967": "Briefly and concisely describe your job description.",
  "text968": "College",
  "text969": "Faculty",
  "text970": "Department",
  "text971": "Secondary school",
  "text972": "Course name",
  "text973": "Description of the study",
  "text974": "Briefly and concisely describe your studies",
  "text975": "Complete beginner",
  "text976": "The Basics",
  "text977": "Intermediate",
  "text978": "Advanced",
  "text979": "Expert",
  "text980": "Add language",
  "text981": "Add knowledge",
  "text982": "Complete beginner (A1)",
  "text983": "Beginner (A2)",
  "text984": "Intermediate (B1)",
  "text985": "Intermediate (B2)",
  "text986": "Advanced (C1)",
  "text987": "Expert (C2)",
  "text988": "Adding a language",
  "text989": "Language",
  "text990": "Language level",
  "text991": "You have no added education",
  "text992": "Today",
  "text993": "Course or certificate",
  "text994": "This website uses cookies",
  "text995": "We use cookies to personalise content and ads, provide social media features and analyse traffic. We also provide information about how you use our website to our social media, advertising and analytics partners. These partners may combine the relevant information with other information that you have provided to them or that they have collected from you when you have used their services.",
  "text996": "Enable everything",
  "text997": "Reject",
  "text998": "Customize",
  "text999": "Cookies settings",
  "text1000": "Services",
  "text1001": "Your privacy options",
  "text1002": "In this section you can express some preferences regarding the processing of your personal data. You can review and change the expressed preferences at any time by revisiting this panel via the link provided. If you wish to refuse your consent to the specific processing activities described below, toggle the toggle switch to off or use the \"Refuse All\" button to confirm that you wish to save your choices.",
  "text1003": "Needed",
  "text1004": "Necessary cookies help to create usable websites by enabling basic functions such as site navigation and access to protected areas of the website. The website cannot function properly without these cookies.",
  "text1005": "Statistics and analysis",
  "text1006": "Statistical cookies help website owners understand how to interact with website visitors by collecting and reporting information anonymously.",
  "text1007": "Cookie table",
  "text1008": "Cookie",
  "text1009": "Domain",
  "text1010": "Marketing",
  "text1011": "Marketing cookies are used to track visitors to the website. The intent is to serve ads that are relevant and engaging to individual users and thus more valuable to publishers and third-party advertisers.",
  "text1012": "I want to know more",
  "text1013": "For information about the processing of personal data and your rights in relation to the protection of personal data, you can contact us",
  "text1014": "here.",
  "text1015": "Functional",
  "text1016": "Functional cookies help perform certain functions, such as sharing website content on social media platforms, collecting feedback and other third-party features.",
  "text1017": "Save settings",
  "text1018": "You have no added work experience",
  "text1019": "You have no added knowledge",
  "text1020": "Type of skills and knowledge",
  "text1021": "Level of skill and knowledge",
  "text1022": "Adding knowledge and skills",
  "text1023": "What languages do you speak?",
  "text1024": "Enter the languages you speak and their level",
  "text1025": "You have no languages added",
  "text1026": "Back to",
  "text1027": "Continue",
  "text1028": "Save",
  "text1029": "The value must be from the range",
  "text1030": "Adding education",
  "text1031": "I'm still studying",
  "text1032": "Description of the study",
  "text1033": "Title",
  "text1034": "Technical information",
  "text1035": "Technical features",
  "text1036": "Do you have a question about the product? Send it to us and we will be happy to answer it.",
  "text1037": "Product name",
  "text1038": "Send inquiry",
  "text1039": "I consent to the processing of personal data",
  "text1040": "Your question",
  "text1041": "Send to",
  "text1042": "Your question has been sent successfully",
  "text1043": "Question could not be sent",
  "text1044": "Your name",
  "text1045": "Reza",
  "text1046": "This product is available in several variants",
  "text1047": "Share on Facebook",
  "text1048": "Minimum height",
  "text1049": "Minimum width",
  "text1050": "Maximum height",
  "text1051": "Maximum width",
  "text1052": "Colour design",
  "text1053": "January",
  "text1054": "February",
  "text1055": "March",
  "text1056": "April",
  "text1057": "May",
  "text1058": "June",
  "text1059": "July",
  "text1060": "August",
  "text1061": "September",
  "text1062": "October",
  "text1063": "November",
  "text1064": "December",
  "text1065": "Course length",
  "text1066": "Number of chapters",
  "text1067": "Enter original spare part number",
  "text1068": "Payment Methods",
  "text1069": "With account you can track your orders and manage invoice",
  "text1070": "Only new",
  "text1071": "Only used",
  "text1072": "Used parts",
  "text1073": "Blog articles, hints and tips",
  "text1074": "Stay with us",
  "text1075": "About the project",
  "text1076": "Action detail",
  "text1077": "Until the end of the event",
  "text1078": "Until the start of the event",
  "text1079": "Previous lesson",
  "text1080": "Ended",
  "text1081": "Krokov",
  "text1082": "Course success rate",
  "text1083": "Open the full discussion",
  "text1084": "Join the discussion",
  "text1085": "Course length",
  "text1086": "List of chapters",
  "text1087": "Course description",
  "text1088": "Frequently asked questions",
  "text1089": "Discussion",
  "text1090": "Buy a course",
  "text1091": "References",
  "text1092": "Mark as met",
  "text1093": "Start the course",
  "text1094": "Exit the course",
  "text1095": "Another lesson",
  "text1096": "Congratulations",
  "text1097": "You have successfully completed the course",
  "text1098": "Without",
  "text1099": "The Gap",
  "text1100": "Dot",
  "text1101": "Line",
  "text1102": "Unknown",
  "text1103": "The new password must be different from the old one",
  "text1104": "Account",
  "text1105": "Created at",
  "text1106": "Subtotal",
  "text1107": "The customer account is not valid.",
  "text1108": "Password confirmation",
  "text1109": "Purchased training",
  "text1110": "Open",
  "text1111": "Trainer",
  "text1112": "You might like",
  "text1113": "Private person",
  "text1114": "Add address",
  "text1115": "Add to cart",
  "text1116": "Back to videos",
  "text1117": "Price offer",
  "text1118": "Send request",
  "text1119": "Deliver completely",
  "text1120": "External order number",
  "text1121": "Export of products completed",
  "text1122": "with VAT",
  "text1123": "New user",
  "text1124": "New order",
  "text1125": "New comment on the task",
  "text1126": "Changing the status of a task",
  "text1127": "Free shipping",
  "text1128": "Price guarantee",
  "text1129": "Free consultation",
  "text1130": "Customer support",
  "text1131": "2000+ products in stock",
  "text1132": "Delivery within 4 days",
  "text1133": "Brands",
  "text1134": "My profile",
  "text1135": "Enter company name",
  "text1136": "Please enter the registration number",
  "text1137": "Enter your company address",
  "text1138": "Place of realization",
  "text1139": "I am interested in",
  "text1140": "Near the creek",
  "text1141": "How many people will use the treatment plant?",
  "text1142": "Do I have sloping land?",
  "text1143": "",
  "text1144": "Design your product exactly to your liking. With our configurator, creating the perfect product is quick and easy.",
  "text1145": "Create your ideal configuration",
  "text1146": "View all in subcategory",
  "text1147": "Photo tutorial",
  "text1148": "Read article",
  "text1149": "Most read articles",
  "text1150": "Tags",
  "text1151": "Are you planning a project?\nWe will meet and advise you.",
  "text1152": "free",
  "text1153": "Contact us",
  "text1154": "Calculate",
  "text1155": "Share article",
  "text1156": "The link has been copied to the clipboard",
  "text1157": "Budget",
  "text1158": "Loyalty points could not be used",
  "text1159": "Your Loyalty Points",
  "text1160": "Each loyalty has a value",
  "text1161": ", giving you a total discount",
  "text1162": "on your purchase.",
  "text1163": "You have no loyalty points",
  "text1164": "Redeem loyalty points",
  "text1165": "Number of points to apply",
  "text1166": "Number of loyalty points redeemed",
  "text1167": "Discount applied",
  "text1168": "The maximum number of points that can be redeemed per order is",
  "text1169": "Headquarters",
  "text1170": "More about the service",
  "text1171": "Get in touch",
  "text1172": "Office",
  "text1173": "Company headquarters",
  "text1174": "Keep going",
  "text1175": "Implementation process and procedure",
  "text1176": "A preview of the screens of the universal e-shop",
  "text1177": "The selected time cannot be booked",
  "text1178": "Selected option",
  "text1179": "Rooms",
  "text1180": "Area",
  "text1181": "Drawing of furniture drawings",
  "text1182": "List of furnishing elements",
  "text1183": "Customer's full name",
  "text1184": "Name of the complaint status",
  "text1185": "Name of the person who will handle the reservation",
  "text1186": "Booked for the day",
  "text1187": "If you already have an account with us, please",
  "text1188": "Company name",
  "text1189": "Address of the registered office of the company",
  "text1190": "Select a country",
  "text1191": "Assigned tabs do not belong to this section",
  "text1192": "Horizontal",
  "text1193": "Vertically",
  "text1194": "Internal",
  "text1195": "Outdoor",
  "text1196": "Work, employment and career opportunities",
  "text1197": "Popular positions",
  "text1198": "Update Cart",
  "text1199": "Edit item",
  "text1200": "Contract number",
  "text1201": "After Warranty Service",
  "text1202": "Log in form",
  "text1203": "Login name (email)",
  "text1204": "Log in",
  "text1205": "Incorrect password",
  "text1206": "Enter the password for the virtual product that you received after you paid for your order.",
  "text1207": "The password can be found on your email address.",
  "text1208": "The item in the cart has been modified.",
  "text1209": "API key is not correct",
  "text1210": "Signing of the contract and payment of the invoice",
  "text1211": "Contact details and work specification",
  "text1212": "Data and access control",
  "text1213": "Graphic design",
  "text1214": "Signature of the Acceptance Protocol - Design",
  "text1215": "Installing the system on the domain - server",
  "text1216": "Visual implementation and connection to the system",
  "text1217": "Acceptance protocol - Design implementation and connection to the system",
  "text1218": "Content of the project",
  "text1219": "Migration to production",
  "text1220": "Final project confirmation",
  "text1221": "The works contract has not been signed.",
  "text1222": "The invoice has not been paid.",
  "text1223": "The contract has been successfully signed.",
  "text1224": "The invoice has been paid.",
  "text1225": "Downloads",
  "text1226": "To the shop",
  "text1227": "Download the document",
  "text1228": "My invoices",
  "text1229": "Document",
  "text1230": "Invoiced amount",
  "text1231": "Amount paid",
  "text1232": "Remains to be paid",
  "text1233": "Currency",
  "text1234": "Date of issue",
  "text1235": "Approved by",
  "text1236": "Equipped by the client",
  "text1237": "Document type",
  "text1238": "Date of taxable supply",
  "text1239": "My inquiry",
  "text1240": "Enter your e-mail address through which we will communicate",
  "text1241": "Date of adoption",
  "text1242": "More about us",
  "text1243": "I am interested",
  "text1244": "Insulation",
  "text1245": "According to use",
  "text1246": "According to the material",
  "text1247": "All references",
  "text1248": "Selected projects",
  "text1249": "Are you interested in implementing a project or do you have questions? Get in touch with us",
  "text1250": "Name and surname",
  "text1251": "The project was supported by the European Union",
  "text1252": "Protection of personal data",
  "text1253": "Product overview",
  "text1254": "View product",
  "text1255": "Technical data",
  "text1256": "Consultation",
  "text1257": "Account number",
  "text1258": "Phone number",
  "text1259": "In our communication with the client, we prefer to communicate through the project group on the \"Whatsapp\" application. Enter the number through which we will add you to the project group.",
  "text1260": "Whatsapp phone number (+421 ... ...)",
  "text1261": "Whatsapp",
  "text1262": "Work specification",
  "text1263": "Type of work (by agreement and contract)",
  "text1264": "Eshop",
  "text1265": "Presentation website",
  "text1266": "Web application",
  "text1267": "Mobile application",
  "text1268": "CRM system",
  "text1269": "PPC campaigns (Google, Facebook)",
  "text1270": "SEO optimization",
  "text1271": "Type of design",
  "text1272": "E-shop design - Eliadmin universal",
  "text1273": "E-shop design - bespoke design",
  "text1274": "Web design / application design / system design",
  "text1275": "Preferred color code (in HEX format)",
  "text1276": "You can mix it at this link.",
  "text1277": "Graphic and content documents",
  "text1278": "Graphic documents",
  "text1279": "I have (e.g. design manual, logo, banner...)",
  "text1280": "I don't have",
  "text1281": "Background content for the website (descriptions, category names, photos, etc...)",
  "text1282": "Attach supporting files (design manual, logo, banners, ...)",
  "text1283": "For logo vector use vector format svg, ai or pdf.",
  "text1284": "Upload up to 10 supported files. Maximum size 100 MB/file.",
  "text1285": "FIND A FILE",
  "text1286": "Domain and hosting",
  "text1287": "I have purchased",
  "text1288": "Domain name (www.vasadomena.sk)",
  "text1289": "Domain name",
  "text1290": "Domain Provider Name",
  "text1291": "Provider name",
  "text1292": "Your login name",
  "text1293": "Your login password",
  "text1294": "Note necessary for system installation (it will speed up the work and the actual handover of the product, if you do not have it we can arrange)",
  "text1295": "Booking form",
  "text1296": "Choice of service",
  "text1297": "Choose a barber",
  "text1298": "Select the term",
  "text1299": "Enter your contact",
  "text1300": "Current free dates",
  "text1301": "Undecided",
  "text1302": "Monday",
  "text1303": "Tuesday",
  "text1304": "Wednesday",
  "text1305": "Thursday",
  "text1306": "Friday",
  "text1307": "Saturday",
  "text1308": "Sunday",
  "text1309": "The Week",
  "text1310": "No dates available",
  "text1311": "Summary",
  "text1312": "Name of barber",
  "text1313": "Service",
  "text1314": "Duration",
  "text1315": "minutes",
  "text1316": "Send reservation",
  "text1317": "The booking was successful",
  "text1318": "It is necessary to choose the date",
  "text1319": "The reservation could not be established. Please check that the form is filled in correctly and try to create the reservation again.",
  "text1320": "There was an unexpected mistake.",
  "text1321": "More info",
  "text1322": "See more projects",
  "text1323": "Project detail",
  "text1324": "Contact us if you are interested\nabout professionals in their field!",
  "text1325": "Projects",
  "text1326": "See projects",
  "text1327": "Project name",
  "text1328": "Year of implementation",
  "text1329": "Location",
  "text1330": "Reference sheet",
  "text1331": "Company data",
  "text1332": "Bank",
  "text1333": "Call",
  "text1334": "Insert token",
  "text1335": "Booking",
  "text1336": "Go to category",
  "text1337": "Navigate",
  "text1338": "Stay in the loop by subscribing to our newsletter!",
  "text1339": "By entering your email address, you confirm your consent to the processing of your personal data and you also subscribe to the Spaceplan newsletter.",
  "text1340": "Book now",
  "text1341": "I have a loyalty card",
  "text1342": "Error when recording a reservation",
  "text1343": "Book selected products",
  "text1344": "More about our company",
  "text1345": "Our services",
  "text1346": "Connect with us",
  "text1347": "You have successfully unsubscribed from the newsletter",
  "text1348": "Create a new",
  "text1349": "Cancel and discard",
  "text1350": "Do you want to cancel CV creation? All data will be lost.",
  "text1351": "Drop your CV",
  "text1352": "Continue creating",
  "text1353": "Attribute selection error.",
  "text1354": "Contact no later than",
  "text1355": "Online price calculation",
  "text1356": "Select the products you are interested in pricing:",
  "text1357": "View quote",
  "text1358": "Selected products for calculation:",
  "text1359": "Add product",
  "text1360": "Read more",
  "text1361": "I'm interested in the product",
  "text1362": "Are you interested in this product? Fill out the form and we will contact you as soon as possible with a price offer.",
  "text1363": "It is necessary to select the product in the previous step",
  "text1364": "Without configuration",
  "text1365": "Fill in the attached form and we will get back to you as soon as possible. Even in this step it is still a non-binding quotation for you",
  "text1366": "Project",
  "text1367": "Contact no later than",
  "text1368": "Send a non-binding enquiry for an individual offer",
  "text1369": "Download the quote",
  "text1370": "Inspect",
  "text1371": "This product has no settings.",
  "text1372": "The non-binding enquiry for an individual offer has been successfully sent",
  "text1373": "Executive",
  "text1374": "Business and services",
  "text1375": "Have a question? Message us",
  "text1376": "If you have a question and need to get in touch with us, try calling or writing to us, or you can fill out the contact form.",
  "text1377": "See project",
  "text1378": "Interested in products and services?",
  "text1379": "Designer",
  "text1380": "Apply filter",
  "text1381": "You have no favorite products",
  "text1382": "Delete wishlist",
  "text1383": "Do you really want to delete your wishlist?",
  "text1384": "Delete",
  "text1385": "Don't delete",
  "text1386": "Invalid phone number",
  "text1387": "Invalid telephone area code",
  "text1388": "All properties",
  "text1389": "Sale",
  "text1390": "Rent",
  "text1391": "Purchase",
  "text1392": "Show offer",
  "text1393": "Artists",
  "text1394": "Submit order with obligation to pay",
  "text1395": "I want to sell",
  "text1396": "I want to buy",
  "text1397": "I want to rent",
  "text1398": "No delivery locations available",
  "text1399": "Amenities",
  "text1400": "Back to realties",
  "text1401": "Show all images",
  "text1402": "We see that you have added products to your favorites when you were not logged in. Would you like to add products to your favourites?",
  "text1403": "Add",
  "text1404": "Do not accept",
  "text1405": "The customer cannot be assigned.",
  "text1406": "Search for a product",
  "text1407": "Location",
  "text1408": "Location of the property",
  "text1409": "Type of property",
  "text1410": "Select",
  "text1411": "Enter keyword",
  "text1412": "Select a price range",
  "text1413": "Real Estate",
  "text1414": "Budgets",
  "text1415": "Company headquarters",
  "text1416": "I am interested in",
  "text1417": "Yes",
  "text1418": "New buildings only",
  "text1419": "No real estate",
  "text1420": "real estate on offer",
  "text1421": "Sort by",
  "text1422": "I want to sell",
  "text1423": "Property",
  "text1424": "Real Estate",
  "text1425": "property on offer",
  "text1426": "properties on offer",
  "text1427": "by",
  "text1428": "Contact",
  "text1429": "Choose which type of account you wish to create with us",
  "text1430": "User",
  "text1431": "Student",
  "text1432": "Company",
  "text1433": "School",
  "text1434": "company website",
  "text1435": "Address of the company's registered office",
  "text1436": "Company registration",
  "text1437": "If you already have an account with us, please",
  "text1438": "log in.",
  "text1439": "The company's operation is different with the company's headquarters",
  "text1440": "Contact details of the responsible person",
  "text1441": "The password must contain a minimum of 8 characters.",
  "text1442": "for the purpose of creating an account and contacting you.",
  "text1443": "All projects",
  "text1444": "New",
  "text1445": "Learn more about the product",
  "text1446": "Buy product",
  "text1447": "Attachments for download",
  "text1448": "Total price without VAT",
  "text1449": "Price per piece without VAT",
  "text1450": "Price of goods without VAT",
  "text1451": "Total excluding VAT",
  "text1452": "Configuration preview",
  "text1453": "Expand All",
  "text1454": "Product configuration",
  "text1455": "Surface finishes",
  "text1456": "Surface treatment of the back",
  "text1457": "Door design",
  "text1458": "Edges",
  "text1459": "Handles",
  "text1460": "Hinges",
  "text1461": "Ornaments",
  "text1462": "Dimensions",
  "text1463": "Additional data",
  "text1464": "Enter the number of pieces",
  "text1465": "Number of pieces",
  "text1466": "Clean configuration",
  "text1467": "Close configurator",
  "text1468": "Configurator",
  "text1469": "Preview",
  "text1470": "Configure",
  "text1471": "Invalid configuration",
  "text1472": "I think it's time",
  "text1473": "Set the number of pieces",
  "text1474": "To add to cart you need to set the number of pieces",
  "text1475": "My addresses",
  "text1476": "User registration",
  "text1477": "Student registration",
  "text1478": "School registration",
  "text1479": "Name of school",
  "text1480": "school website",
  "text1481": "School address",
  "text1482": "Fields of study at the school",
  "text1483": "Email of a school employee",
  "text1484": "Official school email",
  "text1485": "Add department",
  "text1486": "Fill in the field",
  "text1487": "The API configuration for Google Analytics is not filled in.",
  "text1488": "Export generation started",
  "text1489": "Export generation completed",
  "text1490": "Are you looking for a job? Fill out the contact form",
  "text1491": "Did you not find an offer in the currently available job positions? No problem, fill out the contact form, upload your CV and we will contact you if there is a vacancy.",
  "text1492": "Career",
  "text1493": "Briefly describe the position you would be interested in...",
  "text1494": "Important contacts",
  "text1495": "Favorite offers",
  "text1496": "Area of ​​operation",
  "text1497": "Size of the business",
  "text1498": "Interesting company facts",
  "text1499": "Company description",
  "text1500": "Overview of offers",
  "text1501": "Description of the school",
  "text1502": "Overview of study fields",
  "text1503": "Date of entrance exams",
  "text1504": "Open day",
  "text1505": "Cooperation / Professional practice",
  "text1506": "There is no record.",
  "text1507": "Courses",
  "text1508": "Edit profile",
  "text1509": "Previous work experience",
  "text1510": "Education and qualifications",
  "text1511": "Personal skills",
  "text1512": "Other skills",
  "text1513": "Nationality",
  "text1514": "Place of work",
  "text1515": "What school are you studying?",
  "text1516": "What type of work are you looking for?",
  "text1517": "Not filled in",
  "text1518": "Company profile",
  "text1519": "Remove all",
  "text1520": "Advertisements",
  "text1521": "School profile",
  "text1522": "Searched companies",
  "text1523": "View profile",
  "text1524": "Job offers in",
  "text1525": "Clean the filter",
  "text1526": "Information about the job offer",
  "text1527": "Salary",
  "text1528": "Department",
  "text1529": "Position",
  "text1530": "Number of vacancies",
  "text1531": "Validity of job offer",
  "text1532": "Required skills",
  "text1533": "Other information",
  "text1534": "Create a profile",
  "text1535": "Previous work experience",
  "text1536": "Education and qualifications",
  "text1537": "Save and resume later",
  "text1538": "Select gender",
  "text1539": "What is your field?",
  "text1540": "Basic company data",
  "text1541": "Logo",
  "text1542": "Interesting facts about the company",
  "text1543": "Company slogan",
  "text1544": "Briefly describe your company and what it does...",
  "text1545": "Write here an interesting fact about your company...",
  "text1546": "Write your company slogan...",
  "text1547": "Contact details of the company",
  "text1548": "Do you provide internships for students?",
  "text1549": "Would you welcome cooperation with schools?",
  "text1550": "Yes",
  "text1551": "No",
  "text1552": "Facebook link",
  "text1553": "Instagram link",
  "text1554": "Linkedin link",
  "text1555": "Area of activity",
  "text1556": "Company size",
  "text1557": "Select company size",
  "text1558": "List of references",
  "text1559": "School profile",
  "text1560": "Basic school data",
  "text1561": "School projects",
  "text1562": "The address is in the wrong format",
  "text1563": "Creating a company profile will serve as your business card.",
  "text1564": "Fields of study at the school",
  "text1565": "Schools",
  "text1566": "Companies",
  "text1567": "Try an effective applicant search",
  "text1568": "Jobiis Matching will recommend a suitable candidate to you.",
  "text1569": "Add an offer",
  "text1570": "School contact details",
  "text1571": "Fields of study at the school",
  "text1572": "Short description of the school",
  "text1573": "Interesting facts about the school",
  "text1574": "Briefly describe your school...",
  "text1575": "Post your job offer and find the right candidate",
  "text1576": "Use our portal to post a job offer and find your candidate who meets your job criteria in a short time.",
  "text1577": "Connect with companies and find a partner for an apprenticeship or internship for your students.",
  "text1578": "Jobiis will make it easy for you to access work experience or internship opportunities for your students.",
  "text1579": "Would you be interested in organizing a lecture with an expert at your school?",
  "text1580": "We can help you organize a lecture with an expert in your field at no charge!",
  "text1581": "Find your match.",
  "text1582": "Add department",
  "text1583": "Order",
  "text1584": "Upload logo",
  "text1585": "School cooperation",
  "text1586": "Projects in which the school is involved",
  "text1587": "Open Doors Date",
  "text1588": "Date of the entrance examination",
  "text1589": "Select the date",
  "text1590": "Select membership type",
  "text1591": "If you would like to order from us to another country, please write to us at",
  "text1592": "and we will process your order individually.",
  "text1593": "Add a project",
  "text1594": "Add cooperation",
  "text1595": "Company description",
  "text1596": "Your area of activity",
  "text1597": "Social networks",
  "text1598": "In which circle do you want to work",
  "text1599": "What is your field?",
  "text1600": "What type of job are you looking for?",
  "text1601": "Expected salary in € (per month)",
  "text1602": "Start immediately",
  "text1603": "Working times",
  "text1604": "Position title",
  "text1605": "It still persists",
  "text1606": "Add more",
  "text1607": "Title Qualification",
  "text1608": "Educational organisation",
  "text1609": "Permanent education",
  "text1610": "website of the organization",
  "text1611": "Delete",
  "text1612": "Language skills",
  "text1613": "Mother tongue",
  "text1614": "Other languages",
  "text1615": "Digital skills",
  "text1616": "Which digital skills do you have?",
  "text1617": "What category of licence do you hold?",
  "text1618": "Type of job",
  "text1619": "Job description",
  "text1620": "Position suitable for",
  "text1621": "Lower salary threshold in €",
  "text1622": "Upper salary limit in €",
  "text1623": "Industry",
  "text1624": "Employee benefits",
  "text1625": "Working time",
  "text1626": "Required minimum age",
  "text1627": "Completed education",
  "text1628": "Required education in the field",
  "text1629": "Language skills",
  "text1630": "Previous experience required",
  "text1631": "Necessary qualifications",
  "text1632": "Personality prerequisites",
  "text1633": "Information for applicants",
  "text1634": "Diploma",
  "text1635": "Choose the type of work",
  "text1636": "What school are you studying",
  "text1637": "Choose convenient working hours",
  "text1638": "Add a skill",
  "text1639": "Select the departments",
  "text1640": "Choose the type of work",
  "text1641": "Creative works",
  "text1642": "Conferences and seminars",
  "text1643": "Hobbies and interests",
  "text1644": "Honours and awards",
  "text1645": "Networks and memberships",
  "text1646": "Projects",
  "text1647": "Publications",
  "text1648": "References",
  "text1649": "Volunteer activities",
  "text1650": "Select a skill type",
  "text1651": "Skill level",
  "text1652": "Name of the creative work",
  "text1653": "Description of the creative work",
  "text1654": "Upload file",
  "text1655": "Name of the conference",
  "text1656": "Link to the seminar/conference",
  "text1657": "Description of the seminar/conference",
  "text1658": "Name of hobby/interest",
  "text1659": "Description of hobbies/interests",
  "text1660": "Name of the award/award",
  "text1661": "Description of the distinction/award",
  "text1662": "Transferring institution",
  "text1663": "Date of handover",
  "text1664": "Name of membership",
  "text1665": "Membership description",
  "text1666": "Project name",
  "text1667": "Project description",
  "text1668": "Title of publication",
  "text1669": "Date of publication",
  "text1670": "Description of the publication",
  "text1671": "Name of reference",
  "text1672": "Upload reference sheet",
  "text1673": "Position (referendum)",
  "text1674": "Email (referendums)",
  "text1675": "Telephone number (referendum)",
  "text1676": "Location",
  "text1677": "Name of the volunteering activity",
  "text1678": "Description of volunteering activity",
  "text1679": "Link to file/video",
  "text1680": "Other",
  "text1681": "You have no skills added",
  "text1682": "Your profile has been successfully updated",
  "text1683": "Upload profile picture",
  "text1684": "Add an advert",
  "text1685": "Create an advert",
  "text1686": "Wage type",
  "text1687": "Location",
  "text1688": "My messages",
  "text1689": "Incorrect token, try again",
  "text1690": "Search by offer name, industry, location",
  "text1691": "Today it is",
  "text1692": "Contacts",
  "text1693": "Speech",
  "text1694": "How to choose an active session",
  "text1695": "The downloadable document and access password will be available only after payment is confirmed.",
  "text1696": " Reset password",
  "text1697": "Show reference detail",
  "text1698": "Realization",
  "text1699": "Place",
  "text1700": "All realization visualizations",
  "text1701": "Back to all realizations",
  "text1702": "Product detail",
  "text1703": "No users",
  "text1704": "Search for users",
  "text1705": "To",
  "text1706": "Contact form from the web",
  "text1707": "Student registration",
  "text1708": "Navigate to store",
  "text1709": "If you want to be informed about the latest news, completion dates and options, subscribe to our newsletter and receive the latest information directly to your inbox.",
  "text1710": "Mon - Sat: 8:00 - 19:00",
  "text1711": "We will answer you within 24 hours. during working hours.",
  "text1712": "Sample shop",
  "text1713": "A personal meeting must be arranged in advance.",
  "text1714": "Fill out the form and we will answer your question as soon as possible.",
  "text1715": "Show more",
  "text1716": "Sort",
  "text1717": "Practice for students",
  "text1718": "Cooperation with schools",
  "text1719": "Age",
  "text1720": "Delete chat",
  "text1721": "No messages",
  "text1722": "We are preparing this product for you",
  "text1723": "Company address",
  "text1724": "Contact person",
  "text1725": "www address",
  "text1726": "Title before name",
  "text1727": "Characteristics of the company",
  "text1728": "Select an area",
  "text1729": "Finish the offer",
  "text1730": "Required knowledge of languages",
  "text1731": "Required education",
  "text1732": "Required work experience",
  "text1733": "Type of job offer",
  "text1734": "My account",
  "text1735": "My biography",
  "text1736": "My job offers",
  "text1737": "My courses",
  "text1738": "My company",
  "text1739": "Biographies",
  "text1740": "Resume and certificates",
  "text1741": "Photo and video",
  "text1742": "Skills and knowledge",
  "text1743": "Categories of industries",
  "text1744": "Upload your resume for employer download.",
  "text1745": "Certificate",
  "text1746": "Upload the certificates you have available.",
  "text1747": "Letter of motivation",
  "text1748": "Upload motivation letter.",
  "text1749": "A photo is not mandatory, but a resume with a photo looks more personal and attracts the recruiter more.",
  "text1750": "Upload your video resume that will move you one step closer to your desired job position.",
  "text1751": "Did you know that it takes an average of 7 seconds for a recruiter to scan a CV for the first time? So only mention relevant experiences and describe them in bullet points or short paragraphs.",
  "text1752": "Let employers know what your education is.",
  "text1753": "Enter what skills and knowledge you have and at what level.",
  "text1754": "Add other sections to your resume that are important to you.",
  "text1755": "Title after name",
  "text1756": "Choose the industry categories you want to apply for from the list",
  "text1757": "Our social networks",
  "text1758": "Our references",
  "text1759": "Other references",
  "text1760": "Our team",
  "text1761": "\nCurrent offer",
  "text1762": "Invalid key",
  "text1763": "\nWe implemented",
  "text1764": "Environmentally friendly industrial chemicals",
  "text1765": "How do we make products?",
  "text1766": "Possibility to work from home?",
  "text1767": "Starting day",
  "text1768": "Description of the job offer",
  "text1769": "Contact details for responding to the offer",
  "text1770": "Add the required work experience and the level of experience required from the applicant.",
  "text1771": "Add the required education required of the applicant.",
  "text1772": "Add required language skills for this job position",
  "text1773": "Add other parts to the offer that are required from the bidder.",
  "text1774": "Name of work experience",
  "text1775": "Level of work experience",
  "text1776": "Add new",
  "text1777": "Secondary education",
  "text1778": "First degree university education",
  "text1779": "Higher education II. degree",
  "text1780": "Higher education III. degree",
  "text1781": "Level",
  "text1782": "Select the driver's license categories you require from the applicant.",
  "text1783": "Your resume has been successfully updated",
  "text1784": "Finish CV",
  "text1785": "New answer in the consultation",
  "text1786": "You have a new answer in the counseling room",
  "text1787": "Question has been successfully added",
  "text1788": "Added",
  "text1789": "Reactions to the ad",
  "text1790": "Years",
  "text1791": "Download CV",
  "text1792": "Packaging",
  "text1793": "Find your local store",
  "text1794": "\nCatalog number",
  "text1795": "Delivery 7 - 10 days",
  "text1796": "Register",
  "text1797": "You have no job offers",
  "text1798": "Researched resumes",
  "text1799": "It doesn't matter",
  "text1800": "Search for manufacturer, name, series, product code...",
  "text1801": "Choose quality and beauty - shop with us!",
  "text1802": "We are a direct importer of these manufacturers",
  "text1803": "Regular price for",
  "text1804": "Our price for",
  "text1805": "Price for 1 pack",
  "text1806": "Enter the surface area to calculate the amount of packages",
  "text1807": "Enter the desktop content",
  "text1808": "packing",
  "text1809": "Choose a softskill",
  "text1810": "Select a level",
  "text1811": "Watch video",
  "text1812": "No new notifications",
  "text1813": "Sell with us",
  "text1814": "We cooperate with the following carriers",
  "text1815": "Edit ad",
  "text1816": "Recommended job positions",
  "text1817": "Open position",
  "text1818": "Contact us",
  "text1819": "Similar positions",
  "text1820": "We reserve the right not to respond to applicants who do not meet the stated requirements.",
  "text1821": "About company",
  "text1822": "List of companies",
  "text1823": "Reject all",
  "text1824": "Website",
  "text1825": "How many items do you have?",
  "text1826": "How many orders do you have per month?",
  "text1827": "match",
  "text1828": "Accepted",
  "text1829": "Yes, I want to receive occasional news and tips about e-commerce services.",
  "text1830": "Rejected",
  "text1831": "Waiting",
  "text1832": "He responded",
  "text1833": "Soft skills",
  "text1834": "Choose from over 60 brands in our portfolio and find exactly what you are looking for! Everything is fully customizable - from upholstery to colors. Contact us and together we will create a custom design according to your ideas.",
  "text1835": "Show products",
  "text1836": "Where will it go?",
  "text1837": "child",
  "text1838": "children",
  "text1839": "children",
  "text1840": "adult",
  "text1841": "adults",
  "text1842": "adults",
  "text1843": "1 to 3 nights",
  "text1844": "4 to 6 nights",
  "text1845": "7 to 15 nights",
  "text1846": "16+ nights",
  "text1847": "Select the number of nights",
  "text1848": "More options",
  "text1849": "New question",
  "text1850": "Place, location, hotel",
  "text1851": "Date from - to",
  "text1852": "Number of passengers",
  "text1853": "Length of stay",
  "text1854": "Food",
  "text1855": "Close",
  "text1856": "Show more options",
  "text1857": "Maximum price per person",
  "text1858": "More",
  "text1859": "Qualification type",
  "text1860": "No tours meet the specified criteria.",
  "text1861": "Learn more",
  "text1862": "More blogs from the last week",
  "text1863": "Seller",
  "text1864": "Price list of biographies",
  "text1865": "New wholesale registration",
  "text1866": "At all",
  "text1867": "Not much",
  "text1868": "Neutral",
  "text1869": "A little more",
  "text1870": "Very",
  "text1871": "Do you find it interesting?",
  "text1872": "You have successfully completed the test",
  "text1873": "Done",
  "text1874": "You are most suitable for",
  "text1875": "Show free positions",
  "text1876": "I am not a VAT payer",
  "text1877": "Show all notifications",
  "text1878": "Notifications",
  "text1879": "Unread",
  "text1880": "Mark all as read",
  "text1881": "No notifications",
  "text1882": "Number of records to display",
  "text1883": "You have",
  "text1884": "new message",
  "text1885": "new messages",
  "text1886": "new messages",
  "text1887": "Answer to the advertisement application",
  "text1888": "Reaction to advertisement",
  "text1889": "Complete your profile",
  "text1890": "New job offer",
  "text1891": "Offer will expire soon",
  "text1892": "The company showed interest",
  "text1893": "New applicant",
  "text1894": "Update your profile",
  "text1895": "System notification",
  "text1896": "You have a new candidate for a job offer",
  "text1897": "added a new job offer",
  "text1898": "she showed interest in you",
  "text1899": "sale",
  "text1900": "Latest blogs",
  "text1901": "Recommended products",
  "text1902": "News and discounts",
  "text1903": "Category detail",
  "text1904": "To continue, complete all questions",
  "text1905": "Send test",
  "text1906": "Special offer",
  "text1907": "\nI want to sell through Loft.cz",
  "text1908": "Enter your email and don't miss out on unique offers",
  "text1909": "Service",
  "text1910": "Infoline",
  "text1911": "Suitable work areas",
  "text1912": "Suitable working environment",
  "text1913": "Join us",
  "text1914": "Expected salary",
  "text1915": "Favorite companies",
  "text1916": "Go to all schools",
  "text1917": "Subscription",
  "text1918": "Last seen",
  "text1919": "My events\n",
  "text1920": "Next blog",
  "text1921": "Previous blog",
  "text1922": "\nPokračujte na nákup předplatného.",
  "text1923": "Delivery country",
  "text1924": "Do you need to contact us? Write to us at",
  "text1925": "WP",
  "text1926": "RP",
  "text1927": "Active subscription",
  "text1928": "In case of cancellation of the subscription, your subscription remains active until the end of the subscription period.",
  "text1929": "Subscription history",
  "text1930": "Download invoice",
  "text1931": "Subscription activated",
  "text1932": "Skills",
  "text1933": "Have you already purchased a subscription?",
  "text1934": "Sign in to your account.",
  "text1935": "The subscription includes access to all dance classes, workouts and other information, a 10% discount on all Danceana OZ events for registered users.",
  "text1936": "Create your credentials.",
  "text1937": "Beginning",
  "text1938": "End",
  "text1939": "Partners",
  "text1940": "Buy subscription",
  "text1941": "All events",
  "text1942": "Less",
  "text1943": "All albums",
  "text1944": "See gallery",
  "text1945": "What do you get?",
  "text1946": "I want to become a partner",
  "text1947": "All",
  "text1948": "Lecturers",
  "text1949": "Other courses which\nmight interest you",
  "text1950": "Business conditions",
  "text1951": "There are no courses available in this category.",
  "text1952": "Save data change",
  "text1953": "Please verify your email address",
  "text1954": "Verify",
  "text1955": "About me",
  "text1956": "So far",
  "text1957": "Values",
  "text1958": "To complete the registration, it is necessary to confirm the email address",
  "text1959": "Send confirmation email again",
  "text1960": "The confirmation email has been sent again",
  "text1961": "An error occurred while sending the confirmation email",
  "text1962": "The email address has been successfully verified",
  "text1963": "Search for schools",
  "text1964": "No schools",
  "text1965": "Select a location",
  "text1966": "Subscribe to the newsletter and always receive the most up-to-date information from our offer",
  "text1967": "Clients have said about us",
  "text1968": "No properties match the selected filter",
  "text1969": "You would be most suitable for the positions",
  "text1970": "Suitable job positions",
  "text1971": "Employment benefits",
  "text1972": "Qualifications",
  "text1973": "The email address could not be verified",
  "text1974": "Run test",
  "text1975": "Do you really want to delete this ad?",
  "text1976": "day",
  "text1977": "days",
  "text1978": "days",
  "text1979": "Hide supplier list",
  "text1980": "Show list of suppliers",
  "text1981": "Check availability with the seller",
  "text1982": "Select dealer",
  "text1983": "Select a dealer",
  "text1984": "Hide dealer list",
  "text1985": "Show list of sellers",
  "text1986": "Thank you, we have registered your request, we will contact you within a few hours",
  "text1987": "Favorite schools",
  "text1988": "If you don't have an account with us yet",
  "text1989": "This school does not yet have a verified profile",
  "text1990": "Save resume PDF",
  "text1991": "Contact interested party",
  "text1992": "Driving licenses",
  "text1993": "Browse products",
  "text1994": "The value must be from an interval",
  "text1995": "Enter",
  "text1996": "Basic level",
  "text1997": "Select the length of your membership",
  "text1998": "Price for 1 month subscription",
  "text1999": "Select number of resumes",
  "text2000": "All blogs",
  "text2001": "Subscribe to our newsletter and be the first to receive the hottest information about discounts, news and events.",
  "text2002": "By submitting your newsletter subscription, you agree to",
  "text2003": "Didn't find the answer to your question?",
  "text2004": "Contact us and ask",
  "text2005": "Our rental shop",
  "text2006": "Rental office",
  "text2007": "Do you need advice or have a question about a product? Contact us and we will get back to you.",
  "text2008": "Write us",
  "text2009": "Required education/experience in the field",
  "text2010": "Send interest in a job offer",
  "text2011": "Interest in the job offer has been sent",
  "text2012": "View companies",
  "text2013": "Do you need advice? Contact us",
  "text2014": "Show all",
  "text2015": "I do not agree to send a satisfaction questionnaire within the Heureka program Verified by customers.",
  "text2016": "Add social networks",
  "text2017": "Price including 23% VAT",
  "text2018": "Rental conditions HERE",
  "text2019": "Sign up",
  "text2020": "Already have an account?",
  "text2021": "Choose a motorcycle",
  "text2022": "Search by motorcycle name...",
  "text2023": "No products were found for",
  "text2024": "No products available in this category",
  "text2025": "Clear all",
  "text2026": "May only contain numbers",
  "text2027": "Type of school",
  "text2028": "Back to motorcycle selection",
  "text2029": "Thank you, your request for a test drive has been sent.",
  "text2030": "We will contact you as soon as possible and arrange a date for your test drive.",
  "text2031": "Back to main page",
  "text2032": "Specialization",
  "text2033": "Highest completed education",
  "text2034": "Address of the place of work",
  "text2035": "I have my own pattern",
  "text2036": "Send us your own design / pattern through this form and we will give you a price\n              production.",
  "text2037": "Course dates",
  "text2038": "Add softskill",
  "text2039": "The interest was sent successfully",
  "text2040": "Interest in the job offer has already been realized.",
  "text2041": "Are you sure you want to send an interest in this job offer?",
  "text2042": "Confirm interest",
  "text2043": "Confirm purchase",
  "text2044": "Are you sure you want to purchase a subscription?",
  "text2045": "Period",
  "text2046": "months",
  "text2047": "Turn on notifications",
  "text2048": "New offer from the employer",
  "text2049": "New response to offer interest",
  "text2050": "Popular ad expiration notification",
  "text2051": "New interest of the company",
  "text2052": "schools",
  "text2053": "Displayed",
  "text2054": "Trade unions",
  "text2055": "Place of wanted work",
  "text2056": "Expected salary",
  "text2057": "Distance to work",
  "text2058": "Working hours",
  "text2059": "Profile creation date",
  "text2060": "Recommended resolutions",
  "text2061": "The product will be downloadable after the payment of the order",
  "text2062": "You do not have a fully filled out profile",
  "text2063": "First name, last name and at least 1 soft skill are required",
  "text2064": "At least 1 soft skill",
  "text2065": "Creating a profile will also serve as your resume. Please complete the individual steps and answer the following questions.",
  "text2066": "Cancel acceptance of applicant",
  "text2067": "You want to confirm the applicant's interest",
  "text2068": "Accept the applicant",
  "text2069": "The applicant's interest is being confirmed",
  "text2070": "Confirm",
  "text2071": "Accept interest",
  "text2072": "Reject interest",
  "text2073": "The candidate will receive a message that you have accepted him",
  "text2074": "Practice for students",
  "text2075": "No offers",
  "text2076": "View",
  "text2077": "offer",
  "text2078": "offers",
  "text2079": "Accept all",
  "text2080": "Confirm all offers",
  "text2081": "This action will confirm the interest in the work of all candidates whose application has the status \"Pending\"",
  "text2082": "Candidates will receive a message that you have accepted them",
  "text2083": "Confirming all offers...",
  "text2084": "Concept",
  "text2085": "Active",
  "text2086": "Archived",
  "text2087": "Save draft",
  "text2088": "Add a soft skill",
  "text2089": "The account will be deleted for",
  "text2090": "Are you sure you want to delete the account?",
  "text2091": "View my resume in the resume database",
  "text2092": "unlock resume",
  "text2093": "You are not a Jobiis Partner",
  "text2094": "If you want to buy resume unlocks at a discounted price, first you need to activate the \"Jobiis Partner\" subscription",
  "text2095": "The form is not filled out",
  "text2096": "Show reactions",
  "text2097": "Remove advertisement",
  "text2098": "Archive",
  "text2099": "Activate",
  "text2100": "Archived",
  "text2101": "Active",
  "text2102": "Form filled in incorrectly",
  "text2103": "The form is not filled out correctly. Check the form and send it again.",
  "text2104": "You do not have this bio unlocked",
  "text2105": "Unlock resume",
  "text2106": "In order to access the information on this resume, the resume must be unlocked.",
  "text2107": "Unlock",
  "text2108": "Remaining free unlocks",
  "text2109": "Unlocks remaining purchased",
  "text2110": "CV has been unlocked",
  "text2111": "View resume",
  "text2112": "Unpaid",
  "text2113": "Pay",
  "text2114": "Topping",
  "text2115": "No products in the cart",
  "text2116": "You don't have enough credit",
  "text2117": "Corporate benefits",
  "text2118": "Offer suitable for foreigners",
  "text2119": "Offer suitable for a graduate",
  "text2120": "Education courses",
  "text2121": "Make a connection with your future job",
  "text2122": "I am an employer",
  "text2123": "I am a candidate",
  "text2124": "Pay bid",
  "text2125": "Unlock offer for free",
  "text2126": "Free offers",
  "text2127": "unlock menu",
  "text2128": "Article",
  "text2129": "Partner",
  "text2130": "Use free offer",
  "text2131": "remains",
  "text2132": "Use free topping",
  "text2133": "My CV",
  "text2134": "Topped",
  "text2135": "Total for payment",
  "text2136": "Order Summary",
  "text2137": "Continue to summary",
  "text2138": "Products to buy",
  "text2139": "Delivery address",
  "text2140": "Back to shipping and billing information",
  "text2141": "for order processing and marketing purposes.",
  "text2142": "I agree to send information about news, discounts and price promotions.",
  "text2143": "maximum 600 characters",
  "text2144": "Add the company data according to the ID number",
  "text2145": "Add data",
  "text2146": "You have not filled out your data",
  "text2147": "Your profile does not have complete billing information.",
  "text2148": "Valid until",
  "text2149": "maximum 600 characters",
  "text2150": "Mandatory",
  "text2151": "Do you want to save the changes you made?",
  "text2152": "Do not save",
  "text2153": "Topped to",
  "text2154": "No reactions to the offer",
  "text2155": "Buy resumes",
  "text2156": "Search by city",
  "text2157": "months",
  "text2158": "Professional practice for students",
  "text2159": "Qualification/education title",
  "text2160": "Achieved education",
  "text2161": "Education/qualification organization",
  "text2162": "The entered email already exists",
  "text2163": "Size of the business",
  "text2164": "Select the size of the company",
  "text2165": "View benefits",
  "text2166": "Basic",
  "text2167": "The content is not valid XML",
  "text2168": "The content is not valid JSON",
  "text2169": "Purchase in installments",
  "text2170": "Moon",
  "text2171": "You have no education/qualification added",
  "text2172": "Report an error",
  "text2173": "Brief unlocks",
  "text2174": "Unlock offers",
  "text2175": "Topping",
  "text2176": "Error description",
  "text2177": "An error was reported",
  "text2178": "Report another error",
  "text2179": "Error is being sent",
  "text2180": "A menu saved as a draft must have a name",
  "text2181": "Verification of availability of goods",
  "text2182": "Seller's address",
  "text2183": "Hello, in the eshop",
  "text2184": "we registered the customer's demand for the following goods:",
  "text2185": "Please inform us if you have the requested goods in the store so that we can inform the customer.",
  "text2186": "Regards, Sales Department",
  "text2187": "Your profile is not filled out yet",
  "text2188": "In order for companies to be able to see your profile, it is necessary to fill in the following data",
  "text2189": "Fill in profile",
  "text2190": "If you want companies to see your profile in the resume database, you need to fill in the following information:",
  "text2191": "Finish profile",
  "text2192": "Admin",
  "text2193": "Update",
  "text2194": "Interest profile",
  "text2195": "Choose lecturer",
  "text2196": "\nOther classes of the lecturer",
  "text2197": "Course of the camp",
  "text2198": "Teaching team",
  "text2199": "Individual courses",
  "text2200": "Logged",
  "text2201": "All halls",
  "text2202": "Full schedule",
  "text2203": "Event gallery",
  "text2204": "Media",
  "text2205": "Didn't find the answer to your question? Contact us.",
  "text2206": "Instructor",
  "text2207": "About the lecturer",
  "text2208": "What types of dance do I teach?",
  "text2209": "Levels of dance skills",
  "text2210": "Lecturer's gallery",
  "text2211": "Dancer",
  "text2212": "Teacher",
  "text2213": "Classification (select from options) *",
  "text2214": "Enter the name of the dance group / art school and where it operates",
  "text2215": "Select a school",
  "text2216": "In case of problems, please contact us",
  "text2217": "This email will serve as your login name.",
  "text2218": "You will receive a verification email after registration.",
  "text2219": "terms of subscription",
  "text2220": "Subscription Terms",
  "text2221": "The offer is not fully filled. If you want to publish the offer, edit the offer so that all required fields are filled in.",
  "text2222": "If you want to save the offer as a draft, you need to fill in the name of the offer.",
  "text2223": "Bidding payment",
  "text2224": "Offer will be published only after payment",
  "text2225": "You can pay the offer on the profile in the section",
  "text2226": "Job offer",
  "text2227": "I agree to recurring payments",
  "text2228": "Price list",
  "text2229": "Creating a school profile will serve as your school's business card.",
  "text2230": "Congratulations! Your advertisement application has been approved. Click to open a chat with the company.",
  "text2231": "Unfortunately, your advertisement application has been rejected.",
  "text2232": "\nCourse successfully added to cart",
  "text2233": "Items in cart",
  "text2234": "Person",
  "text2235": "Legal entity (company)",
  "text2236": "Classification",
  "text2237": "\nChoose from the options",
  "text2238": "Enter your email",
  "text2239": "Enter phone number",
  "text2240": "Enter a name",
  "text2241": "Enter last name",
  "text2242": "Edit menu",
  "text2243": "Before purchasing a subscription, you must be logged in",
  "text2244": "Don't have an account yet?",
  "text2245": "Create it here\n",
  "text2246": "Gallery",
  "text2247": "\nImpress",
  "text2248": "with a professional",
  "text2249": "video resume",
  "text2250": "Recipe",
  "text2251": "\nCreate a professional resume",
  "text2252": "Card number",
  "text2253": "Expiration",
  "text2254": "CVV",
  "text2255": "MM / YY",
  "text2256": "Lecturer",
  "text2257": "Access course content via ",
  "text2258": "subscription.",
  "text2259": "If you have purchased a subscription,",
  "text2260": "log in.",
  "text2261": "\nYou have no favorite courses.",
  "text2262": "Remove card",
  "text2263": "Bicycle service",
  "text2264": "Pay and publish",
  "text2265": "Pay later",
  "text2266": "Link to react to the offer",
  "text2267": "Leave the field empty if you want to manage responses to the offer in our system",
  "text2268": "Send interest directly",
  "text2269": "Paid",
  "text2270": "Unsubscribe",
  "text2271": "If you do not wish to receive emails, click on the link",
  "text2272": "Our address",
  "text2273": "Visit us",
  "text2274": "Name on Card",
  "text2275": "Incorrect private key format",
  "text2276": "We recommend ordering",
  "text2277": "Add a DXF file to the message, if there are multiple files, pack them into .rar or .zip\n",
  "text2278": "Ask for price",
  "text2279": "Enter quantity",
  "text2280": "Your price inquiry has been sent. We will contact you via your e-mail address.",
  "text2281": "I'm not interested",
  "text2282": "They bought from us",
  "text2283": "More than 2,789 satisfied customers",
  "text2284": "Selected categories",
  "text2285": "300m2 shop",
  "text2286": "Mon-Fri: 8:30 - 17:00",
  "text2287": "Bonus club",
  "text2288": "Are you sure you want to log out?",
  "text2289": "Yes, log out",
  "text2290": "Save changes",
  "text2291": "create it here.",
  "text2292": "If you don't have an account yet,",
  "text2293": "No, cancel",
  "text2294": "Satisfied customer",
  "text2295": "Person",
  "text2296": "Company",
  "text2297": "In stock",
  "text2298": "at your address",
  "text2299": "Explore",
  "text2300": "Top selling products",
  "text2301": "Load more",
  "text2302": "Sort",
  "text2303": "Shipping immediately",
  "text2304": "Compare",
  "text2305": "Technical parameters",
  "text2306": "Add a review",
  "text2307": "An error occurred while updating your profile.",
  "text2308": "General provisions",
  "text2309": "The main offer",
  "text2310": "Information about your order",
  "text2311": "The order has been paid",
  "text2312": "The order has not been paid yet",
  "text2313": "\nContinue down",
  "text2314": "TOP selection",
  "text2315": "Explore TOP picks for every garden",
  "text2316": "Loved by homeowners\nacross Slovakia",
  "text2317": "The most popular wooden structures and accessories for your garden",
  "text2318": "Explore our best-selling categories of wooden gazebos, houses, sheds and accessories. Quality and fast delivery throughout Slovakia.",
  "text2319": "\nAll categories",
  "text2320": "What makes our products special?",
  "text2321": "Technical details",
  "text2322": "Our latest references",
  "text2323": "Qualification",
  "text2324": "Why choose wooden gazebos and houses?",
  "text2325": "Do you also want your dream garden house or gazebo?",
  "text2326": "Discover the offer",
  "text2327": "Benefits",
  "text2328": "What do you get with our products?",
  "text2329": "I am interested in a consultation.",
  "text2330": "Implementations",
  "text2331": "Satisfied customer stories",
  "text2332": "More realizations",
  "text2333": "Interesting articles to read",
  "text2334": "Didn't find the answer to your question? Don't hesitate to contact us.",
  "text2335": "Play video",
  "text2336": "Are you ready to transform your garden?",
  "text2337": "Do you need advice? Feel free to contact us either via the contact form or directly via the contact details below.",
  "text2338": "Fill out the form.",
  "text2339": "What are you interested in?",
  "text2340": "Your message",
  "text2341": "By submitting the form you agree to",
  "text2342": "processing of personal data.",
  "text2343": "Send message",
  "text2344": "Subscribe to our newsletter and get the most up-to-date information about our offer.",
  "text2345": "Don't remember your password?",
  "text2346": "Please fill in the order number and e-mail.",
  "text2347": "The order for the specified combination of order number and email does not exist.",
  "text2348": "You are logged in. You can find all your orders in your profile.",
  "text2349": "The password must contain at least 6 to 64 characters, one uppercase letter and one number.",
  "text2350": "Personal / company data",
  "text2351": "Inventory number",
  "text2352": "Your registration was successful. We have sent you a confirmation link to activate your account in your email inbox.",
  "text2353": "Choose a category according to your preference and find the product you are looking for.",
  "text2354": "Show more categories",
  "text2355": "Sort by",
  "text2356": "About the category",
  "text2357": "Calculator",
  "text2358": "Contact us and we will be happy to help you.",
  "text2359": "This product has no reviews yet. Be the first to share your experience!",
  "text2360": "reviews",
  "text2361": "Order history",
  "text2362": "I'm buying for a company.",
  "text2363": "Confirm password change",
  "text2364": "An error occurred.",
  "text2365": "Place of reference",
  "text2366": "About the project",
  "text2367": "Gallery of the project",
  "text2368": "Client experience",
  "text2369": "Similar realizations",
  "text2370": "Continue to the article",
  "text2371": "Content of the article",
  "text2372": "Mon - Fri",
  "text2373": "Sat - Sun\n\n",
  "text2374": "Closed\n",
  "text2375": "Navigate to traffic",
  "text2376": "We did not find content that meets the search requirements.",
  "text2377": "Thank you for your interest.",
  "text2378": "We will contact you back as soon as possible.",
  "text2379": "Homepage",
  "text2380": "Inspirations",
  "text2381": "Inspirations for your garden",
  "text2382": "See the process of making a garden house and gazebo",
  "text2383": "Us vs competition",
  "text2384": "What are we better at than the competition?",
  "text2385": "Competition",
  "text2386": "Wooden garden gazebos and houses for your garden",
  "text2387": "Quality and affordable prices with delivery in Slovakia",
  "text2388": "Create the perfect space for relaxation, storage or car protection with our wooden gazebos, houses, pergolas and carports. Order today!",
  "text2389": "Price per piece",
  "text2390": "Payment and shipping",
  "text2391": "Only one active category is allowed per API integration.",
  "text2392": "If you have an account with us, log in and we will fill in the details based on your account information.",
  "text2393": "See what our customers rave about. These top-rated products combine style, functionality, and affordability.",
  "text2394": "Check out our most popular wooden structures, made from quality spruce or pine for durability and charm. Perfect for any outdoor space.",
  "text2395": "Application form",
  "text2396": "Useful links",
  "text2397": "Become a member",
  "text2398": "Members area",
  "text2399": "First name/Last name/Company name",
  "text2400": "Workplace (e.g. biochemical laboratory)",
  "text2401": "Institution (e.g. NsP Bratislava)",
  "text2402": "for marketing and contact purposes",
  "text2403": "Processing of personal data",
  "text2404": "Find out more",
  "text2405": "Welcome to the members' area",
  "text2406": "Documents",
  "text2407": "Statutes",
  "text2408": "Code of ethics",
  "text2409": "Presidency",
  "text2410": "Minutes and documents",
  "text2411": "List of representatives of association members",
  "text2412": "IVD Market Statistics",
  "text2413": "Receivables",
  "text2414": "I agree to be sent a satisfaction questionnaire as part of the Heureka Customer Verified program, which helps improve our services.",
  "text2415": "Meet your lecturer",
  "text2416": "Search by company name or ID number",
  "text2417": "No companies were found",
  "text2418": "Unknown payment gateway",
  "text2419": "You have no active subscriptions.",
  "text2420": "Buy it here.",
  "text2421": "Payer type",
  "text2422": "Eq. price",
  "text2423": "Meterage",
  "text2424": "Purchased courses",
  "text2425": "You have no courses purchased.",
  "text2426": "Course overview.",
  "text2427": "Lépj hátra",
  "text2428": "You can check the status of your order at any time by clicking the button below",
  "text2429": "We have received your e-prescription reservation. Check your email inbox.",
  "text2430": "Unfilled",
  "text2431": "Thank you for sending the reservation!",
  "text2432": "Your reservation has been successfully sent.",
  "text2433": "Data sent",
  "text2434": "Upload a photo of the recipe",
  "text2435": "Selected photos",
  "text2436": "Take a photo",
  "text2437": "Image of e-prescription",
  "text2438": "As a bidder",
  "text2439": "I already have an account, I want one",
  "text2440": "As an employer",
  "text2441": "Identification number (IČO)",
  "text2442": "Address and headquarters of the company",
  "text2443": "Edit CV",
  "text2444": "Profile changes saved successfully",
  "text2445": "Ask our expert",
  "text2446": "Preferred location",
  "text2447": "Work on weekends",
  "text2448": "Work during the night",
  "text2449": "Additional information",
  "text2450": "Work preferences",
  "text2451": "No CVs match the selected filters",
  "text2452": "In order to add a new job offer, it is necessary to fill in all mandatory fields.",
  "text2453": "Basic information about the position",
  "text2454": "Applicant requirements",
  "text2455": "Timing type",
  "text2456": "Select the required type of driver's license",
  "text2457": "Add another language",
  "text2458": "Estimated start date",
  "text2459": "Enter information about the place of work.",
  "text2460": "Wage conditions",
  "text2461": "Indicate the payment terms for the bidder",
  "text2462": "Remove menu",
  "text2463": "Current offers",
  "text2464": "This company has no active offers",
  "text2465": "Describe your business",
  "text2466": "We provide internships for students",
  "text2467": "We cooperate with schools",
  "text2468": "Blog content",
  "text2469": "Similar blogs",
  "text2470": "Read useful blogs.",
  "text2471": "Register",
  "text2472": "Add to cart",
  "text2473": "Advanced search",
  "text2474": "Search in",
  "text2475": "Please wait for email and SMS",
  "text2476": "Clear filter",
  "text2477": "Partial match with product name",
  "text2478": "Short product description",
  "text2479": "EAN product code",
  "text2480": "External product code",
  "text2481": "Product code",
  "text2482": "Start typing an address",
  "text2483": "Candidates",
  "text2484": "The oldest candidates",
  "text2485": "The youngest candidates",
  "text2486": "Latest reactions",
  "text2487": "Oldest reactions",
  "text2488": "Accepted",
  "text2489": "Not accepted",
  "text2490": "The date is coming soon",
  "text2491": "No courses found",
  "text2492": "shop",
  "text2493": "Training process",
  "text2494": "Missing email template setting in order status",
  "text2495": "Balíkovo self-service boxes",
  "text2496": "Balíkovo business premises",
  "text2497": "Submit",
  "text2498": "Select",
  "text2499": "Selected location",
  "text2500": "COD",
  "text2501": "Total order amount",
  "text2502": "Purchase",
  "text2503": "Use free topping",
  "text2504": "credit",
  "text2505": "credits",
  "text2506": "credits",
  "text2507": "Payment with credits",
  "text2508": "The shipment for the order is not ready",
  "text2509": "The order has already been shipped",
  "text2510": "The carrier does not offer automated shipping",
  "text2511": "Don't show next time",
  "text2512": "Number of persons",
  "text2513": "Retry payment is not allowed for the payment method",
  "text2514": "The payment gateway does not currently support API refunds",
  "text2515": "Create a reminder",
  "text2516": "Editing a reminder",
  "text2517": "Deleting reminder",
  "text2518": "Product creation",
  "text2519": "Product modification",
  "text2520": "Deleting the product",
  "text2521": "Prize creation",
  "text2522": "Price adjustment",
  "text2523": "Deleting the price",
  "text2524": "Creating a property type",
  "text2525": "Editing property type",
  "text2526": "Deleting property type",
  "text2527": "Creating property listing type",
  "text2528": "Editing property listing type",
  "text2529": "Deleting property listing type",
  "text2530": "Creating a room",
  "text2531": "Room modification",
  "text2532": "Deleting the room",
  "text2533": "Creating a property label",
  "text2534": "Property label modification",
  "text2535": "Delete property tag",
  "text2536": "Creation of additional property information",
  "text2537": "Modification of additional property information",
  "text2538": "Deleting additional property information",
  "text2539": "Creating the value of additional property information",
  "text2540": "Modification of the value of additional property information",
  "text2541": "Deleting the value of additional property information",
  "text2542": "Creating a city",
  "text2543": "Town adjustment",
  "text2544": "Erase the city",
  "text2545": "Creation of the municipality",
  "text2546": "Regulation of the municipality",
  "text2547": "Deleting the village",
  "text2548": "Creating a property text field",
  "text2549": "Property text field modification",
  "text2550": "Clearing a property text field",
  "text2551": "Creation of property category",
  "text2552": "Modification of property category",
  "text2553": "Deleting a property category",
  "text2554": "Creating a property rule",
  "text2555": "Modification of the property rule",
  "text2556": "Deleting the property rule",
  "text2557": "Creating a property rule response",
  "text2558": "Property rule answer modification",
  "text2559": "Deleting property rule response",
  "text2560": "Creating a property reservation",
  "text2561": "Modification of property reservation",
  "text2562": "Deleting a property reservation",
  "text2563": "Creating a property destination",
  "text2564": "Adjustment of property destination",
  "text2565": "Deleting a property destination",
  "text2566": "Creating a property position",
  "text2567": "Modification of real estate position",
  "text2568": "Deleting a property position",
  "text2569": "Establishment of a real estate agency",
  "text2570": "Modification of real estate agency",
  "text2571": "Deletion of real estate agency",
  "text2572": "Creating a real estate broker",
  "text2573": "Modification of real estate agent",
  "text2574": "Deleting a real estate agent",
  "text2575": "Creation of a real estate developer",
  "text2576": "Modification of the real estate developer",
  "text2577": "Deleting the real estate developer",
  "text2578": "Creation of real estate",
  "text2579": "Modification of real estate",
  "text2580": "Deletion of real estate",
  "text2581": "Creation of real estate price",
  "text2582": "Real estate price adjustment",
  "text2583": "Deleting the property price",
  "text2584": "Creating a custom property rule",
  "text2585": "Amendment of own property rule",
  "text2586": "Deleting a custom property rule",
  "text2587": "Creating a bookable property day",
  "text2588": "Modification of the bookable day of the property",
  "text2589": "Deleting the bookable day of the property",
  "text2590": "Creating course type",
  "text2591": "Course type modification",
  "text2592": "Deleting course type",
  "text2593": "Creating course category",
  "text2594": "Modify course category",
  "text2595": "Deleting course category",
  "text2596": "Creating course text field",
  "text2597": "Editing course text field",
  "text2598": "Clearing course text field",
  "text2599": "Creating a course",
  "text2600": "Course adjustment",
  "text2601": "Course deletion",
  "text2602": "Creation of the consulting room category",
  "text2603": "Modification of the consulting room category",
  "text2604": "Deleting the consultation office category",
  "text2605": "Creating a course price",
  "text2606": "Course price adjustment",
  "text2607": "Deleting course price",
  "text2608": "Creating a course chapter",
  "text2609": "Editing a course chapter",
  "text2610": "Deleting a course chapter",
  "text2611": "Creating a course instructor",
  "text2612": "Editing the course instructor",
  "text2613": "Deleting the course instructor",
  "text2614": "Creating a course level",
  "text2615": "Course Level Adjustment",
  "text2616": "Clear course level",
  "text2617": "Creating a course room",
  "text2618": "Course room modification",
  "text2619": "Deleting a course room",
  "text2620": "Creating a course event",
  "text2621": "Edit course event",
  "text2622": "Course event deletion",
  "text2623": "Creating a course schedule",
  "text2624": "Course schedule modification",
  "text2625": "Deleting the course schedule",
  "text2626": "Creation of employment type",
  "text2627": "Modification of the type of working time",
  "text2628": "Deleting the working time type",
  "text2629": "Creating a job portal label",
  "text2630": "Work portal label modification",
  "text2631": "Deleting job portal label",
  "text2632": "Creating a job portal text field",
  "text2633": "Editing the job portal text field",
  "text2634": "Deleting the job portal text field",
  "text2635": "Creating job portal category",
  "text2636": "Editing job portal category",
  "text2637": "Deleting job portal category",
  "text2638": "Creating job portal payment type",
  "text2639": "Modification of job portal payment type",
  "text2640": "Deleting job portal payment type",
  "text2641": "Creating job portal company size",
  "text2642": "Job portal company size adjustment",
  "text2643": "Deleting job portal company size",
  "text2644": "Creating a job portal company",
  "text2645": "Modification of the job portal company",
  "text2646": "Deleting the job portal company",
  "text2647": "Creating job portal status",
  "text2648": "Modifying job portal status",
  "text2649": "Clearing job portal status",
  "text2650": "Creating job portal attribute value",
  "text2651": "Modifying job portal attribute value",
  "text2652": "Clearing job portal attribute value",
  "text2653": "Creating job portal attribute",
  "text2654": "Modifying job portal attribute",
  "text2655": "Deleting job portal attribute",
  "text2656": "Creating work portal work time",
  "text2657": "Adjustment of work time of job portal",
  "text2658": "Clearing job portal work time",
  "text2659": "Creation of work portal work place",
  "text2660": "Modification of the place of performance of the job portal",
  "text2661": "Deleting the place of work of the work portal",
  "text2662": "Creating an age range job portal",
  "text2663": "Adjusting the age range of the job portal",
  "text2664": "Clearing the age range of the job portal",
  "text2665": "Establishment of required prior work portal experience",
  "text2666": "Adjustment of required prior work portal experience",
  "text2667": "Removal of required previous job portal experience",
  "text2668": "Creating suitability for a job portal position",
  "text2669": "Eligibility adjustment for job portal position",
  "text2670": "Release eligibility for job portal position",
  "text2671": "Creation of completed education job portal",
  "text2672": "Editing completed education job portal",
  "text2673": "Deleting completed education job portal",
  "text2674": "Creating a driver's license job portal",
  "text2675": "Modification of driver's license job portal",
  "text2676": "Deleting the driver's license of the job portal",
  "text2677": "Creation of job portal school type",
  "text2678": "Modification of job portal school type",
  "text2679": "Delete job portal school type",
  "text2680": "Creation of the school department of the job portal",
  "text2681": "Modification of the school section of the job portal",
  "text2682": "Deleting the school section of the job portal",
  "text2683": "Creating a school job portal",
  "text2684": "Modification of the school job portal",
  "text2685": "Deleting the job portal school",
  "text2686": "Creation of the school job portal project",
  "text2687": "Modification of the job portal school project",
  "text2688": "Deleting the job portal school project",
  "text2689": "Establishment of school cooperation job portal",
  "text2690": "Adjustment of school cooperation of the job portal",
  "text2691": "Deleting the cooperation of the school of the job portal",
  "text2692": "Creating a job offer on the job portal",
  "text2693": "Modification of the job offer of the job portal",
  "text2694": "Deleting job portal job offer",
  "text2695": "Creating Job Portal Job Listing Skill",
  "text2696": "Modification of job portal job listing skill",
  "text2697": "Deleting job portal job listing skill",
  "text2698": "Creating job portal job offer salary",
  "text2699": "Wage adjustment of job portal job offer",
  "text2700": "Deleting the salary of the job offer of the job portal",
  "text2701": "Create a job portal resume",
  "text2702": "Job portal resume editing",
  "text2703": "Deleting job portal resume",
  "text2704": "Creating Job Portal Resume Skill",
  "text2705": "Job portal resume skill modification",
  "text2706": "Deleting job portal resume skill",
  "text2707": "Creating work experience resume job portal",
  "text2708": "Work experience modification of job portal resume",
  "text2709": "Deleting work experience from job portal CV",
  "text2710": "Creating job portal resume education",
  "text2711": "Modification of job portal resume education",
  "text2712": "Deletion of job portal resume education",
  "text2713": "Creating job portal resume salary",
  "text2714": "Job portal resume salary adjustment",
  "text2715": "Deleting job portal resume salary",
  "text2716": "Creating travel agency status",
  "text2717": "Adjustment of travel agency status",
  "text2718": "Deleting the status of the travel agency",
  "text2719": "Creating a travel agency label",
  "text2720": "Modification of travel agency label",
  "text2721": "Deleting the travel agency label",
  "text2722": "Creating a travel agency text field",
  "text2723": "Editing the travel agency text field",
  "text2724": "Deleting the travel agency text field",
  "text2725": "Creating travel agency attribute value",
  "text2726": "Editing the value of the travel agency attribute",
  "text2727": "Deleting the travel agency attribute value",
  "text2728": "Creating a travel agency attribute",
  "text2729": "Editing the travel agency attribute",
  "text2730": "Deleting the travel agency attribute",
  "text2731": "Creation of travel agency category",
  "text2732": "Modification of travel agency category",
  "text2733": "Deleting the travel agency category",
  "text2734": "Creating a travel agency tour",
  "text2735": "Modification of travel agency tour",
  "text2736": "Deleting a travel agency tour",
  "text2737": "Creating a travel agency tour date",
  "text2738": "Modification of travel agency tour date",
  "text2739": "Deletion of travel agency tour date",
  "text2740": "Creating a travel agency tour reservation",
  "text2741": "Adjustment of travel agency tour reservation",
  "text2742": "Deleting a travel agency tour reservation",
  "text2743": "Creation of travel agency tour participant",
  "text2744": "Modification of travel agency tour participant",
  "text2745": "Deleting a travel agency tour participant",
  "text2746": "Creating customer type",
  "text2747": "Edit customer type",
  "text2748": "Deleting customer type",
  "text2749": "Creating a customer",
  "text2750": "Customer modification",
  "text2751": "Deleting a customer",
  "text2752": "Creation of customer in customer group",
  "text2753": "Editing a customer in a customer group",
  "text2754": "Deleting a customer from a customer group",
  "text2755": "Creation of customer group",
  "text2756": "Edit customer group",
  "text2757": "Deleting customer group",
  "text2758": "Creating user role",
  "text2759": "Edit user role",
  "text2760": "Deleting user role",
  "text2761": "Creating user",
  "text2762": "Editing user",
  "text2763": "Deleting user",
  "text2764": "Creating a product coupon",
  "text2765": "Modification of product coupon",
  "text2766": "Deleting product coupon",
  "text2767": "Creating coupon",
  "text2768": "Edit coupon",
  "text2769": "Deleting coupon",
  "text2770": "Creating discount coupon",
  "text2771": "Coupon discount adjustment",
  "text2772": "Deleting coupon discount",
  "text2773": "Creating a product gift",
  "text2774": "Editing a product gift",
  "text2775": "Deleting a product gift",
  "text2776": "Creating product accessories",
  "text2777": "Modification of product accessories",
  "text2778": "Deleting product accessories",
  "text2779": "Creating product package",
  "text2780": "Modification of product package",
  "text2781": "Deleting product package",
  "text2782": "Creating a product question",
  "text2783": "Editing product question",
  "text2784": "Deleting product question",
  "text2785": "Creating a virtual product to a product",
  "text2786": "Editing a virtual product to a product",
  "text2787": "Deleting virtual product to product",
  "text2788": "Creating service to product",
  "text2789": "Modification of service to product",
  "text2790": "Deleting product service",
  "text2791": "Creating a product review",
  "text2792": "Editing a product review",
  "text2793": "Deleting product review",
  "text2794": "Creating a product variant",
  "text2795": "Edit product variant",
  "text2796": "Deleting product variant",
  "text2797": "Creating product variant price",
  "text2798": "Price adjustment of product variant",
  "text2799": "Deleting product variant price",
  "text2800": "Create category margin",
  "text2801": "Category margin adjustment",
  "text2802": "Clear category margin",
  "text2803": "Creating a category discount",
  "text2804": "Edit category discount",
  "text2805": "Deleting category discount",
  "text2806": "Creating category",
  "text2807": "Edit category",
  "text2808": "Category deletion",
  "text2809": "Creating attribute value",
  "text2810": "Modifying attribute value",
  "text2811": "Deleting attribute value",
  "text2812": "Creating attribute",
  "text2813": "Editing an attribute",
  "text2814": "Deleting an attribute",
  "text2815": "Creation of Supplier's Margin",
  "text2816": "Supplier Margin Adjustment",
  "text2817": "Deleting supplier's margin",
  "text2818": "Creating vendor discount",
  "text2819": "Supplier discount adjustment",
  "text2820": "Deleting supplier discount",
  "text2821": "Creating supplier",
  "text2822": "Supplier modification",
  "text2823": "Deleting supplier",
  "text2824": "Creating manufacturer",
  "text2825": "Manufacturer modification",
  "text2826": "Delete manufacturer",
  "text2827": "Creating a text field",
  "text2828": "Text field editing",
  "text2829": "Clearing a text field",
  "text2830": "Creating product status",
  "text2831": "Modifying product status",
  "text2832": "Clearing product status",
  "text2833": "Creating a product label",
  "text2834": "Edit product label",
  "text2835": "Delete product label",
  "text2836": "Creating a product gift",
  "text2837": "Editing a product gift",
  "text2838": "Deleting a product gift",
  "text2839": "Creating a gift",
  "text2840": "Editing a gift",
  "text2841": "Deleting a gift",
  "text2842": "Creating a product for an action",
  "text2843": "Modify product to action",
  "text2844": "Deleting the product for the promotion",
  "text2845": "Creating action",
  "text2846": "Edit action",
  "text2847": "Deleting action",
  "text2848": "Creating the stock price",
  "text2849": "Adjustment of share price",
  "text2850": "Deleting the share price",
  "text2851": "Creating a service option",
  "text2852": "Modifying service option",
  "text2853": "Deleting a service option",
  "text2854": "Creating service option price",
  "text2855": "Service option price adjustment",
  "text2856": "Deleting service option price",
  "text2857": "Creating a payment method",
  "text2858": "Modification of payment method",
  "text2859": "Deleting payment method",
  "text2860": "Creating payment method price",
  "text2861": "Modification of payment method price",
  "text2862": "Deleting payment method price",
  "text2863": "Creating payment method discount",
  "text2864": "Modification of payment method discount",
  "text2865": "Deleting payment method discount",
  "text2866": "Creating a transport method",
  "text2867": "Transport method adjustment",
  "text2868": "Deleting the transport method",
  "text2869": "Creating shipping method price",
  "text2870": "Modification of the price of the shipping method",
  "text2871": "Deleting the shipping method price",
  "text2872": "Creating a dispensing point",
  "text2873": "Dispensing point adjustment",
  "text2874": "Deleting a dispensing point",
  "text2875": "Creating a multiproject",
  "text2876": "Multiproject modification",
  "text2877": "Deleting multiproject",
  "text2878": "Creating a region",
  "text2879": "Edit region",
  "text2880": "Delete region",
  "text2881": "Language creation",
  "text2882": "Language modification",
  "text2883": "Language deletion",
  "text2884": "Creation of currency",
  "text2885": "Currency adjustment",
  "text2886": "Currency deletion",
  "text2887": "Land creation",
  "text2888": "Landscape modification",
  "text2889": "Delete country",
  "text2890": "Creating a menu",
  "text2891": "Edit menu",
  "text2892": "Clearing the menu",
  "text2893": "Creating a menu item",
  "text2894": "Edit menu item",
  "text2895": "Delete menu item",
  "text2896": "Creating an email template",
  "text2897": "Email template editing",
  "text2898": "Deleting an email template",
  "text2899": "Creation of VAT",
  "text2900": "Adjustment of VAT",
  "text2901": "Deletion of VAT",
  "text2902": "Creation of wholesale type",
  "text2903": "Wholesale type modification",
  "text2904": "Deleting wholesale type",
  "text2905": "Wholesale creation",
  "text2906": "Modification of wholesale",
  "text2907": "Wholesale deletion",
  "text2908": "Creation of wholesale address",
  "text2909": "Modification of wholesale address",
  "text2910": "Deleting wholesale address",
  "text2911": "Create a wholesale domain",
  "text2912": "Modification of the wholesale domain",
  "text2913": "Deleting the wholesale domain",
  "text2914": "Creating a claim",
  "text2915": "Adjustment of claim",
  "text2916": "Deleting the claim",
  "text2917": "Creation of the reason for the complaint",
  "text2918": "Modification of the reason for the complaint",
  "text2919": "Deleting the reason for the complaint",
  "text2920": "Creating claim status",
  "text2921": "Adjustment of claim status",
  "text2922": "Deleting the claim status",
  "text2923": "Creating page",
  "text2924": "Edit page",
  "text2925": "Deleting page",
  "text2926": "Banner creation",
  "text2927": "Banner modification",
  "text2928": "Deleting banner",
  "text2929": "Gender creation",
  "text2930": "Gender modification",
  "text2931": "Gender deletion",
  "text2932": "Creating a blog product",
  "text2933": "Modification of product to blog",
  "text2934": "Deleting product for blog",
  "text2935": "Create a blog",
  "text2936": "Blog editing",
  "text2937": "Deleting the blog",
  "text2938": "Creating a blog category",
  "text2939": "Edit blog category",
  "text2940": "Deleting blog category",
  "text2941": "Creating a post on a social network",
  "text2942": "Editing a post on a social network",
  "text2943": "Deleting a post on a social network",
  "text2944": "Creating a social network",
  "text2945": "Editing a social network",
  "text2946": "Deleting the social network",
  "text2947": "Newsletter creation",
  "text2948": "Modification of the newsletter",
  "text2949": "Deletion of newsletter",
  "text2950": "Creation of mass mail",
  "text2951": "Modification of mass mail",
  "text2952": "Deleting bulk mail",
  "text2953": "Creating a newsletter label",
  "text2954": "Modification of newsletter label",
  "text2955": "Deleting newsletter label",
  "text2956": "Creating an email newsletter",
  "text2957": "Modification of newsletter email",
  "text2958": "Deleting the newsletter email",
  "text2959": "Creation of loyalty points",
  "text2960": "Modification of loyalty points",
  "text2961": "Deleting loyalty points",
  "text2962": "Creating a consultation response",
  "text2963": "Adjustment of the advice office's answer",
  "text2964": "Deleting the response of the counseling office",
  "text2965": "Establishing a consultation room",
  "text2966": "Editing the consulting room",
  "text2967": "Deleting the consulting room",
  "text2968": "Creating reference category",
  "text2969": "Reference category modification",
  "text2970": "Deleting reference category",
  "text2971": "Creating reference",
  "text2972": "Edit reference",
  "text2973": "Deleting reference",
  "text2974": "Creating service",
  "text2975": "Service modification",
  "text2976": "Deleting service",
  "text2977": "Creation of service price",
  "text2978": "Service price adjustment",
  "text2979": "Deleting the price of the service",
  "text2980": "Creating a career",
  "text2981": "Career modification",
  "text2982": "Career deletion",
  "text2983": "Establishment of mandatory disclosure",
  "text2984": "Regulation of mandatory disclosure",
  "text2985": "Deletion of mandatory disclosure",
  "text2986": "Gallery creation",
  "text2987": "Edit gallery",
  "text2988": "Deleting gallery",
  "text2989": "Creating a team member",
  "text2990": "Editing a team member",
  "text2991": "Deleting a team member",
  "text2992": "Creating customer for subscription",
  "text2993": "Edit customer to subscription",
  "text2994": "Deleting a subscription customer",
  "text2995": "Creating subscription category",
  "text2996": "Edit subscription category",
  "text2997": "Deleting subscription category",
  "text2998": "Creating subscription type",
  "text2999": "Edit subscription type",
  "text3000": "Deleting subscription type",
  "text3001": "Creating subscription type price",
  "text3002": "Subscription type price adjustment",
  "text3003": "Deleting subscription type price",
  "text3004": "Creating subscription",
  "text3005": "Edit subscription",
  "text3006": "Deleting subscription",
  "text3007": "Modifying API configuration",
  "text3008": "Creating order status",
  "text3009": "Modification of order status",
  "text3010": "Deleting order status",
  "text3011": "Creating order status setup",
  "text3012": "Order status setting adjustment",
  "text3013": "Clearing the order status setting",
  "text3014": "Creating an order",
  "text3015": "Edit order",
  "text3016": "Deleting order",
  "text3017": "Creating order shipment",
  "text3018": "Order shipping adjustment",
  "text3019": "Deleting order shipment",
  "text3020": "Creating icon",
  "text3021": "Edit icon",
  "text3022": "Deleting icon",
  "text3023": "Creation of shelter",
  "text3024": "Adapting the shelter",
  "text3025": "Clearing the shelter",
  "text3026": "Creating review type",
  "text3027": "Editing review type",
  "text3028": "Removing review type",
  "text3029": "Creating review",
  "text3030": "Editing review",
  "text3031": "Deleting review",
  "text3032": "Creating configurations",
  "text3033": "Modifying configurations",
  "text3034": "Clearing configurations",
  "text3035": "Creating seo",
  "text3036": "Editing seo",
  "text3037": "Deleting seo",
  "text3038": "Creating redirect",
  "text3039": "Edit redirection",
  "text3040": "Clearing redirect",
  "text3041": "Creating calculator service",
  "text3042": "Modifying the calculator service",
  "text3043": "Deleting the calculator service",
  "text3044": "Creating calculator service price",
  "text3045": "Calculator service price adjustment",
  "text3046": "Deleting the price of the calculator service",
  "text3047": "Creating additional calculator information",
  "text3048": "Modification of additional calculator information",
  "text3049": "Clearing additional calculator information",
  "text3050": "Creating value of additional calculator information",
  "text3051": "Modifying the value of the additional information of the calculator",
  "text3052": "Clearing the calculator's additional information value",
  "text3053": "Creating the price of the additional information value of the calculator",
  "text3054": "Modification of the price of the additional information value of the calculator",
  "text3055": "Deleting the price of the additional information value of the calculator",
  "text3056": "Creating a calculator product",
  "text3057": "Calculator product modification",
  "text3058": "Deleting the calculator product",
  "text3059": "Creating calculator product price",
  "text3060": "Calculator product price adjustment",
  "text3061": "Clearing calculator product price",
  "text3062": "Creating a calculator order",
  "text3063": "Editing calculator order",
  "text3064": "Deleting calculator order",
  "text3065": "Creating a calculator order value",
  "text3066": "Calculator order value adjustment",
  "text3067": "Clearing calculator order value",
  "text3068": "Creating a calculator order service",
  "text3069": "Editing the calculator order service",
  "text3070": "Deleting the calculator order service",
  "text3071": "Travel agency configuration modification",
  "text3072": "Modification of newsletter configuration",
  "text3073": "Modification of bulk mail configuration",
  "text3074": "Loyalty program configuration modification",
  "text3075": "Configuration of abandoned shopping carts",
  "text3076": "Editing SEO configuration",
  "text3077": "Creation of e-prescription status",
  "text3078": "Modification of e-prescription status",
  "text3079": "Deleting the state of the e-prescription",
  "text3080": "Creation of e-prescription",
  "text3081": "Modification of e-prescription",
  "text3082": "Deleting an e-prescription",
  "text3083": "Creating medication reservation status",
  "text3084": "Modification of medication reservation status",
  "text3085": "Deleting medication reservation status",
  "text3086": "Creation of drug reservation product",
  "text3087": "Modification of drug reservation product",
  "text3088": "Deletion of drug reservation product",
  "text3089": "Creating a medication reservation",
  "text3090": "Modification of drug reservation",
  "text3091": "Deletion of medication reservation",
  "text3092": "Creating reservation service",
  "text3093": "Reservation service modification",
  "text3094": "Deleting reservation service",
  "text3095": "Creation of reservation service price",
  "text3096": "Reservation service price adjustment",
  "text3097": "Deleting the reservation service price",
  "text3098": "Creating an automatic reservation schedule",
  "text3099": "Modification of automatic booking schedule",
  "text3100": "Deleting automatic booking schedule",
  "text3101": "Creating booking time",
  "text3102": "Reservation time adjustment",
  "text3103": "Deleting reservation time",
  "text3104": "Creating reservation person",
  "text3105": "Editing the reservation person",
  "text3106": "Deleting reservation person",
  "text3107": "Creating reservation",
  "text3108": "Modifying reservation",
  "text3109": "Deleting reservation",
  "text3110": "General settings configuration modification",
  "text3111": "The login was successful",
  "text3112": "Your account has been successfully linked.",
  "text3113": "You can now safely close this window — the result has been sent to the application.",
  "text3114": "Close window",
  "text3115": "Close this window manually.",
  "text3116": "Follow us on Instagram",
  "text3117": "The link was successfully copied to the clipboard",
  "text3118": "Subscription expires",
  "text3119": "Profile changes saved successfully",
  "text3120": "Profile successfully created",
  "text3121": "We are preparing",
  "text3122": "Your subscription is not active",
  "text3123": "Purchase a 1-year subscription and get unlimited access to all online courses and a 10% discount on events!",
  "text3124": "Purchase a subscription",
  "text3125": "My products",
  "text3126": "Presidency of the SEDMA Association",
  "text3127": "\nYou have already purchased a subscription.",
  "text3128": "Go to courses",
  "text3129": "You can find the order documents in your profile.",
  "text3130": "This product is not available in our eshop",
  "text3131": "Looking for product information...",
  "text3132": "This product is not available in our eshop",
  "text3133": "Creating category gift",
  "text3134": "Edit category gift",
  "text3135": "Deleting category gift",
  "text3136": "The gift has already been assigned",
  "text3137": "Gift is not allowed for this product",
  "text3138": "Purchase courses at our events.",
  "text3139": "The confirmation email was sent successfully",
  "text3140": "The password reset link is invalid",
  "text3141": "Search in fields",
  "text3142": "Exact search",
  "text3143": "The order has been cancelled",
  "text3144": "The payment order was canceled and was not executed.",
  "text3145": "You have been logged out",
  "text3146": "Someone logged in to your account from another device.",
  "text3147": "Editing the configuration of the consulting room",
  "text3148": "Creating inventory",
  "text3149": "Storage adjustment",
  "text3150": "Deleting storage",
  "text3151": "Creating inventory item",
  "text3152": "Editing inventory item",
  "text3153": "Deleting inventory item",
  "text3154": "The file has already been processed in the past",
  "text3155": "Creating purchase of the day",
  "text3156": "Edit purchase of the day",
  "text3157": "Delete purchase of the day",
  "text3158": "Creating the day's purchase item",
  "text3159": "Modification of purchase item of the day",
  "text3160": "Deleting the day's purchase item",
  "text3161": "Show all",
  "text3162": "Creating a discount on the purchase of the day item",
  "text3163": "Adjustment of the purchase of the day item discount",
  "text3164": "Deleting the purchase of the day item discount",
  "text3165": "Creating a product group",
  "text3166": "Modifying product group",
  "text3167": "Deleting a product group",
  "text3168": "Creating product group discount",
  "text3169": "Modify product group discount",
  "text3170": "Deleting product group discount",
  "text3171": "The gift has been added to the order",
  "text3172": "The gift has already been added to the order",
  "text3173": "Creating transport category",
  "text3174": "Modification of transport category",
  "text3175": "Deleting transport category",
  "text3176": "Creation of category shipping price",
  "text3177": "Modification of category shipping price",
  "text3178": "Deleting the shipping price category",
  "text3179": "Name / Name of the company",
  "text3180": "Product parameters",
  "text3181": "Please enter your email address and we will send you a link to reset your password.",
  "text3182": "Create an account",
  "text3183": "Password again",
  "text3184": "Street number",
  "text3185": "Back to login",
  "text3186": "Products on sale",
  "text3187": "Full sale",
  "text3188": "Purchase of the day",
  "text3189": "minutes",
  "text3190": "hour",
  "text3191": "hours",
  "text3192": "hours",
  "text3193": "second",
  "text3194": "seconds",
  "text3195": "seconds",
  "text3196": "The promotion expires on",
  "text3197": "minutes",
  "text3198": "Buy this product",
  "text3199": "Subscribe for news and discounts.",
  "text3200": "You have successfully subscribed to the newsletter.",
  "text3201": "You are logged in. You can find all your orders in your profile.",
  "text3202": "Download price list",
  "text3203": "Send us a fax",
  "text3204": "Correction",
  "text3205": "Bank account (EUR)",
  "text3206": "Our distributors",
  "text3207": "satisfied customers",
  "text3208": "Your account has been successfully created!",
  "text3209": "Load more blogs",
  "text3210": "Do you need advice? Do not hesitate to contact us, either via the contact form or directly by phone or email.",
  "text3211": "Contact us, we will be happy to advise you.",
  "text3212": "Billing and delivery details",
  "text3213": "Creating product shipping price",
  "text3214": "Adjustment of product shipping price",
  "text3215": "Deleting product shipping price",
  "text3216": "The coupon you entered does not exist.",
  "text3217": "I have a discount coupon.",
  "text3218": "Thank you for your order number",
  "text3219": "We have sent you an order confirmation to the email address you provided.",
  "text3220": "No products found",
  "text3221": "Interesting blogs",
  "text3222": "Subscribed",
  "text3223": "Unsubscribe",
  "text3224": "Do you really wish to unsubscribe from the newsletter?",
  "text3225": "The newsletter subscription has been cancelled",
  "text3226": "Unsubscribe from the newsletter",
  "text3227": "With every order",
  "text3228": "Included",
  "text3229": "Order from",
  "text3230": "With every order",
  "text3231": "What do our satisfied customers say?",
  "text3232": "Expired",
  "text3233": "To enter the member area you must be",
  "text3234": "logged in",
  "text3235": "If you are not registered, click on the link",
  "text3236": "Registration.",
  "text3237": "Forgot your password?",
  "text3238": "View category",
  "text3239": "Discounted products",
  "text3240": "Current offer of tours",
  "text3241": "Menu",
  "text3242": "Product added to cart",
  "text3243": "Creating variant supplier",
  "text3244": "Variant vendor modification",
  "text3245": "Deleting variant supplier",
  "text3246": "Creating Variant Supplier Price",
  "text3247": "Variant supplier price adjustment",
  "text3248": "Deleting variant vendor price",
  "text3249": "Coupon is invalid",
  "text3250": "Information about return options and product complaints can be found on the website",
  "text3251": "Returns and complaints",
  "text3252": "Customer line operating hours",
  "text3253": "Mon-Fri: 8:30 - 17:00",
  "text3254": "More than",
  "text3255": "Show all services",
  "text3256": "Hide",
  "text3257": "Gifts for the product",
  "text3258": "Gift with purchase",
  "text3259": "Calculate repayments",
  "text3260": "verified reviews",
  "text3261": "Reason for contacting",
  "text3262": "Invalid authentication. Please try again",
  "text3263": "Phone number is mandatory",
  "text3264": "By subscribing you agree to",
  "text3265": "Sale",
  "text3266": "Fast delivery",
  "text3267": "Fast and safe free delivery for orders over €100.",
  "text3268": "Delivery options",
  "text3269": "30 days to return",
  "text3270": "Not satisfied with the product? You have 30 days to return the item and get your money back.",
  "text3271": "Payment options",
  "text3272": "Client",
  "text3273": "Client rate",
  "text3274": "There are hours left",
  "text3275": "Subscription status",
  "text3276": "Subscription is activated",
  "text3277": "Subscription is not activated",
  "text3278": "Expires",
  "text3279": "Invoicing email",
  "text3280": "Responsible manager (executive)",
  "text3281": "Navigate to the address",
  "text3282": "Bank connection",
  "text3283": "Complaint no.:",
  "text3284": "Date of claim",
  "text3285": "Date of purchase",
  "text3286": "Customer signature",
  "text3287": "Seller's signature",
  "text3288": "day",
  "text3289": "Detailed description of the defect and the condition of the goods",
  "text3290": "Accessories supplied",
  "text3291": "Subject of complaint",
  "text3292": "Proof of purchase",
  "text3293": "Original packaging",
  "text3294": "Processing of claim no.:",
  "text3295": "End date",
  "text3296": "More specification of the performed repair",
  "text3297": "Creating an accident record",
  "text3298": "Editing accident record",
  "text3299": "Deleting the accident record",
  "text3300": "Customer line operating hours",
  "text3301": "Google Reviews",
  "text3302": "Sign up for news",
  "text3303": "Be informed about our discounts and promotions in time.",
  "text3304": "Search for a tour",
  "text3305": "Search for a tour",
  "text3306": "Show all tours",
  "text3307": "I am interested in a tailor-made tour",
  "text3308": "What we can provide for you",
  "text3309": "Destination",
  "text3310": "How many of you would like to travel",
  "text3311": "Which term would suit you best",
  "text3312": "Preferred term",
  "text3313": "Your request for a tailor-made tour has been successfully sent",
  "text3314": "We currently do not support the functionality",
  "text3315": "Files not found",
  "text3316": "Product catalog",
  "text3317": "Has reviewed",
  "text3318": "more than 1000 clients",
  "text3319": "Go to e-shop",
  "text3320": "Download the free e-book",
  "text3321": "Modification of gifts configuration",
  "text3322": "Write us an email",
  "text3323": "Our interesting blogs",
  "text3324": "Not registered yet?",
  "text3325": "Here's what you're missing out on:",
  "text3326": "Sign up",
  "text3327": "FREE Documents",
  "text3328": "Paid documents",
  "text3329": "Didn't find the answer to your question? Contact us directly via contact.",
  "text3330": "Records of occupational diseases, dangerous events, work accidents",
  "text3331": "Health and safety laws and regulations",
  "text3332": "First aid for life-threatening conditions",
  "text3333": "Traumatological plan",
  "text3334": "Logs, checks and reports",
  "text3335": "Guidelines and laws",
  "text3336": "Technical equipment deadlines",
  "text3337": "Employee training protocol",
  "text3338": "Document samples",
  "text3339": "Control and procedures",
  "text3340": "Certificate",
  "text3341": "Edit marketing configuration",
  "text3342": "Creating reservation category",
  "text3343": "Edit booking category",
  "text3344": "Deleting reservation category",
  "text3345": "Do you have an account? Log in and we'll fill in the details for you.",
  "text3346": "You are successfully logged in.",
  "text3347": "Membership includes the following benefits",
  "text3348": "Use coupon",
  "text3349": "Complete protection",
  "text3350": "what matters most to you",
  "text3351": "Fill out the form and we will contact you.",
  "text3352": "Your message / interest",
  "text3353": "By sending the message you agree to",
  "text3354": "for contact purposes.",
  "text3355": "Continue reading",
  "text3356": "Complaint",
  "text3357": "Withdrawal from contract",
  "text3358": "Withdrawal from the contract and claim of goods",
  "text3359": "show all",
  "text3360": "min reading",
  "text3361": "Didn't find the answer to your question? Contact us by phone or email and we will be happy to answer you.",
  "text3362": "Find out more about Sonicube",
  "text3363": "Become a partner",
  "text3364": "Editing reminders configuration",
  "text3365": "Edit reminder scheduling configuration",
  "text3366": "Creating a reminder",
  "text3367": "Edit reminder",
  "text3368": "Deleting reminder",
  "text3369": "By subscribing to the newsletter, you agree to",
  "text3370": "for marketing and newsletter purposes.",
  "text3371": "Fill out the form and we will get back to you within 24 hours.",
  "text3372": "Number of days past due",
  "text3373": "Date assigned for collection",
  "text3374": "A gift for the product",
  "text3375": "Do you need information about products or your order?",
  "text3376": "The note has already been sent to the customer",
  "text3377": "Search",
  "text3378": "More photos",
  "text3379": "The operation failed",
  "text3380": "Method of delivery",
  "text3381": "Description of the defect",
  "text3382": "Your account has been successfully created.",
  "text3383": "We have sent you an email to the email address you provided.",
  "text3384": "Reset the filter",
  "text3385": "The order was successfully sent",
  "text3386": "We have successfully registered your order. You will receive a confirmation to the email address you provided when placing your order.",
  "text3387": "Subscribe and receive tips on how to support regeneration and health.",
  "text3388": "Complaints",
  "text3389": "for marketing purposes.",
  "text3390": "Company",
  "text3391": "Read the article",
  "text3392": "I have a question",
  "text3393": "Product EAN",
  "text3394": "Creating product groups type",
  "text3395": "Editing the type of product groups",
  "text3396": "Deleting product groups type",
  "text3397": "Add a review",
  "text3398": "Tax obligation",
  "text3399": "Product review",
  "text3400": "Rate this product",
  "text3401": "Registration was successful",
  "text3402": "We have sent a verification email to the email address you provided.",
  "text3403": "Text description",
  "text3404": "for the purpose of processing product evaluation.",
  "text3405": "Your code",
  "text3406": "For payment",
  "text3407": "Back to shipping and payment",
  "text3408": "Order with payment obligation",
  "text3409": "Great! Your order is on its way!",
  "text3410": "Thank you for choosing us.",
  "text3411": "You will find the order confirmation in your email and we will keep you informed about its status.",
  "text3412": "Do you have an account with us?",
  "text3413": "Log in and we will fill in the details for you.",
  "text3414": "Order",
  "text3415": "Current password",
  "text3416": "We have sent you a confirmation of your password change to the email address you provided.",
  "text3417": "Search for a product",
  "text3418": "Certificates",
  "text3419": "My projects",
  "text3420": "No SMS integration is active",
  "text3421": "Error validating SMS limits",
  "text3422": "Failed to verify SMS credit status. Check the configuration",
  "text3423": "Insufficient SMS credit",
  "text3424": "Summary of sent reminders",
  "text3425": "the following reminders have been sent to customers",
  "text3426": "Document extraction started. You will be notified when it's done",
  "text3427": "Make an appointment for a consultation",
  "text3428": "We can help you with this too",
  "text3429": "For students",
  "text3430": "offer",
  "text3431": "You will find us",
  "text3432": "The offer has been added to favorites",
  "text3433": "Document configuration modification",
  "text3434": "Number of bids",
  "text3435": "More offers",
  "text3436": "The offer has been modified",
  "text3437": "The offer has been created",
  "text3438": "Help with ordering",
  "text3439": "See all",
  "text3440": "open positions",
  "text3441": "Positions",
  "text3442": "The order has already been paid",
  "text3443": "An invoice is also a delivery note.",
  "text3444": "products",
  "text3445": "Generated by AI",
  "text3446": "monthly",
  "text3447": "View complete CV",
  "text3448": "Why tag an AI image?",
  "text3449": "By ticking, you confirm that the image was created by artificial intelligence.\n        In this way, you help us comply with the AI ​​Act and increase transparency for applicants.",
  "text3450": "Responsibility for proper labeling of AI generated content lies with the advertiser.",
  "text3451": "Unmarked AI content may be subsequently edited or removed by a moderator.",
  "text3452": "Didn't find the answer to your question?",
  "text3453": "Contact us and we will respond as soon as possible.",
  "text3454": "Year of birth",
  "text3455": "The date of birth serves exclusively to verify the user's legal age and ensure compliance with legal requirements. This data is not used for other purposes",
  "text3456": "Select files",
  "text3457": "Maximum number of files is",
  "text3458": "Maximum file size is 2MB",
  "text3459": "Error uploading file",
  "text3460": "Methods of payment",
  "text3461": "Forms of delivery",
  "text3462": "Don't miss any news and current sales!",
  "text3463": "Receive news by subscribing to our newsletter",
  "text3464": "Your email",
  "text3465": "Number of ratings",
  "text3466": "This product has no reviews.",
  "text3467": "Delivery information",
  "text3468": "Fill in your email address to receive a password reset link.",
  "text3469": "Our blogs",
  "text3470": "Sale",
  "text3471": "You do not have access to resumes",
  "text3472": "This section is available for business accounts with prepaid CV access.",
  "text3473": "Show price list",
  "text3474": "Access to resumes is only available for business accounts.",
  "text3475": "Category",
  "text3476": "Hide phone",
  "text3477": "List of positions",
  "text3478": "The selected sequence is not applicable for the document type",
  "text3479": "Open cart",
  "text3480": "Volume discounts",
  "text3481": "Purchase access to resumes",
  "text3482": "Access to resumes",
  "text3483": "For companies",
  "text3484": "Publication of a job offer",
  "text3485": "Offer topping",
  "text3486": "Limited time offer",
  "text3487": "Coupon expires on",
  "text3488": "Subscribe to the newsletter and get a discount!",
  "text3489": "News, current trends and events directly to your e-mail. The subscription includes a discount coupon. Logout at any time for free.",
  "text3490": "No thanks, I don't want a discount",
  "text3491": "Get Coupon",
  "text3492": "When ordering over",
  "text3493": "For all orders",
  "text3494": "The coupon has been sent to your email",
  "text3495": "Get coupon",
  "text3496": "Get information about new products and discounts among the first.",
  "text3497": "Delivery",
  "text3498": "Discover the concept",
  "text3499": "Become a partner",
  "text3500": "Find out about cooperation opportunities",
  "text3501": "points",
  "text3502": "Number of points earned for €1 purchase",
  "text3503": "One point value",
  "text3504": "Maximum discount in percent per order",
  "text3505": "If you want to use the loyalty program, log in",
  "text3506": "Redeem all points",
  "text3507": "Loyalty points have been applied",
  "text3508": "Apply",
  "text3509": "Login email",
  "text3510": "No attachments",
  "text3511": "evaluation",
  "text3512": "ratings",
  "text3513": "ratings",
  "text3514": "Select rating",
  "text3515": "Find out more here",
  "text3516": "Show all parameters",
  "text3517": "Remaining unlocks",
  "text3518": "All data will be available after unlocking the resume.",
  "text3519": "Locked profile",
  "text3520": "Candidate profile",
  "text3521": "Select 1 to 3 categories/positions",
  "text3522": "View all blogs",
  "text3523": "Non-binding quotation",
  "text3524": "Main banner",
  "text3525": "Previous frame",
  "text3526": "Next frame",
  "text3527": "Open popup",
  "text3528": "Show reference on the map",
  "text3529": "Previous page",
  "text3530": "Next page",
  "text3531": "Go to page",
  "text3532": "Go to slide",
  "text3533": "Previous previews",
  "text3534": "View more images",
  "text3535": "More previews",
  "text3536": "Request a partner consultation",
  "text3537": "Our partners can use this label",
  "text3538": "FAQ creation",
  "text3539": "FAQ edit",
  "text3540": "Delete FAQ",
  "text3541": "Creating Schema.org",
  "text3542": "Modification of Schema.org",
  "text3543": "Deleting Schema.org",
  "text3544": "Fill out the form and arrange an initial partnership consultation.",
  "text3545": "Creating a watchdog",
  "text3546": "Guard dog modification",
  "text3547": "Deleting the watchdog",
  "text3548": "HASQO package",
  "text3549": "More information",
  "text3550": "Package",
  "text3551": "The package contains",
  "text3552": "Suitable for",
  "text3553": "Consultation",
  "text3554": "Name of the establishment",
  "text3555": "City of operation",
  "text3556": "Type of operation",
  "text3557": "Size (m²)",
  "text3558": "Scheduled time",
  "text3559": "Tel. number",
  "text3560": "Your details",
  "text3561": "CV is locked",
  "text3562": "CV is available only after purchase. After unlocking, the applicant's full profile will be displayed.",
  "text3563": "Guard dog",
  "text3564": "Watchdog successfully created",
  "text3565": "We will let you know when this product is available again",
  "text3566": "Failed to create watchdog",
  "text3567": "Enter your email and you will be notified when this product becomes available again",
  "text3568": "Guard dogs",
  "text3569": "Watchdog has been removed",
  "text3570": "Failed to remove watchdog",
  "text3571": "You have no watchdogs set",
  "text3572": "Free tops",
  "text3573": "Quatro calculator",
  "text3574": "Select a GLS outlet",
  "text3575": "Project description",
  "text3576": "Which implementation are you interested in?",
  "text3577": "Select",
  "text3578": "Location of implementation",
  "text3579": "Fill in the address",
  "text3580": "Indicative implementation date",
  "text3581": "Name / Company",
  "text3582": "Fill in the name / company name",
  "text3583": "Fill in your email",
  "text3584": "Fill in the phone",
  "text3585": "Your note",
  "text3586": "Note",
  "text3587": "By submitting you agree to",
  "text3588": "Get to know our services",
  "text3589": "Show more realizations",
  "text3590": "Do you have more questions?",
  "text3591": "Do you have another question or didn't find your answer?",
  "text3592": "Working hours",
  "text3593": "Made to order",
  "text3594": "Quality materials",
  "text3595": "Design detail",
  "text3596": "Realization process",
  "text3597": "to subscribe to news",
  "text3598": "Get the latest information from KAUFMANN.",
  "text3599": "Your email",
  "text3600": "By subscribing to the newsletter, you agree to",
  "text3601": "Show on map",
  "text3602": "or",
  "text3603": "Our staff are at your disposal in",
  "text3604": "working days from 8:00 a.m. to 4:00 p.m",
  "text3605": "Warehouse",
  "text3606": "Load more realizations",
  "text3607": "We did not find any results in this category",
  "text3608": "Creating a best selling product",
  "text3609": "Modification of the best selling product",
  "text3610": "Deleting the best selling product",
  "text3611": "Report",
  "text3612": "Reason for reporting",
  "text3613": "Matriculation",
  "text3614": "nights",
  "text3615": "Date of visit",
  "text3616": "Length of the tour",
  "text3617": "Price from",
  "text3618": "Upon request",
  "text3619": "Show tour details",
  "text3620": "Vacancies",
  "text3621": "I am updating the dates",
  "text3622": "All tours are hidden",
  "text3623": "There are no tours available for the selected period",
  "text3624": "Reduce",
  "text3625": "Full screen",
  "text3626": "The dates could not be loaded",
  "text3627": "subcategories",
  "text3628": "Remove selection",
  "text3629": "Reporting an offer",
  "text3630": "Reporting of a company",
  "text3631": "CV submission",
  "text3632": "The report could not be sent",
  "text3633": "Report has been sent",
  "text3634": "biographies",
  "text3635": "biographies",
  "text3636": "Order in process",
  "text3637": "Home",
  "text3638": "Creating order payment",
  "text3639": "Order payment adjustment",
  "text3640": "Deleting order payment",
  "text3641": "Become our unique partner.",
  "text3642": "Sign up for news and information about\nadded new features.",
  "text3643": "New properties",
  "text3644": "Real estate at a top price",
  "text3645": "References of satisfied clients",
  "text3646": "See what our clients think about us.",
  "text3647": "Read articles about attractions in Cyprus",
  "text3648": "All photos",
  "text3649": "Share",
  "text3650": "Completion date",
  "text3651": "Description of the property",
  "text3652": "Tour of the resort",
  "text3653": "Generate PDF",
  "text3654": "Reserving a tour",
  "text3655": "Choosing an online consultation date",
  "text3656": "Properties in Northern Cyprus",
  "text3657": "Number of rooms",
  "text3658": "Real estate office",
  "text3659": "Real estate",
  "text3660": "Resale / Paid intercia",
  "text3661": "Make an appointment for a consultation",
  "text3662": "Zoom call lasts a maximum of 1 hour and we will answer all your questions + you will get\n              free presentation of all available projects we have in Cyprus.",
  "text3663": "Offers",
  "text3664": "Do you have more questions? We would be happy to introduce you to the HASQO concept in practice.",
  "text3665": "Request a consultation",
  "text3666": "Customer zone",
  "text3667": "Shipment",
  "text3668": "Delivery success",
  "text3669": "Customer line",
  "text3670": "I want to get a quote",
  "text3671": "By subscribing to the newsletter, you agree to",
  "text3672": "Choose from news",
  "text3673": "Shop by category",
  "text3674": "TOP selection of products",
  "text3675": "Subscribe to the newsletter and always receive up-to-date information about promotions and news.",
  "text3676": "Your email address...",
  "text3677": "Safe purchase guarantee",
  "text3678": "Methods of transport",
  "text3679": "Our realizations",
  "text3680": "Collections",
  "text3681": "View all collections",
  "text3682": "They trust us",
  "text3683": "Verified and obtained by Google",
  "text3684": "All reviews",
  "text3685": "Verified",
  "text3686": "All filters",
  "text3687": "No products were found",
  "text3688": "Depth",
  "text3689": "Get a quote for your shipment",
  "text3690": "Web created",
  "text3691": "from 9:00 a.m. to 5:00 p.m",
  "text3692": "About service",
  "text3693": "What does the service include?",
  "text3694": "What shipments is the service suitable for?",
  "text3695": "How is it going?",
  "text3696": "View another service",
  "text3697": "What our satisfied clients say",
  "text3698": "Registration email",
  "text3699": "Fill out the form and get an offer",
  "text3700": "Search for shipment",
  "text3701": "Write us a message",
  "text3702": "Get an offer",
  "text3703": "Exit",
  "text3704": "Loyalty system",
  "text3705": "The delivery address is the same as the billing address",
  "text3706": "Name of contact person",
  "text3707": "Surname of contact person",
  "text3708": "The email address cannot be changed, please contact our support.",
  "text3709": "Advice, trends and practical articles",
  "text3710": "Other articles that might interest you",
  "text3711": "Operator",
  "text3712": "Do you need advice?\nContact us and we will be happy to help you.",
  "text3713": "Contact our customer support or write to us through the contact form and our staff will advise you.",
  "text3714": "Your request",
  "text3715": "Send password change request",
  "text3716": "Items in order",
  "text3717": "Order amount",
  "text3718": "was recorded. We are waiting for the payment, and after it is credited to our account, we will then proceed with the implementation. Please check your email",
  "text3719": "See available positions",
  "text3720": "Latest offer",
  "text3721": "Be part of our team",
  "text3722": "Fill out the form and send us your CV. If your profile interests us and meets your requirements, we will contact you.",
  "text3723": "Send us your CV",
  "text3724": "Loading location",
  "text3725": "Target destination",
  "text3726": "Type of goods",
  "text3727": "Weight (approx.)",
  "text3728": "Volume (m3)",
  "text3729": "Show route",
  "text3730": "Complete order",
  "text3731": "Variant",
  "text3732": "Enter discount code",
  "text3733": "Use points",
  "text3734": "Number of points (insert whole number)",
  "text3735": "Warning: Additional customer change on the invoice is not possible.",
  "text3736": "I want to buy for a company",
  "text3737": "The delivery address is different from the billing address.",
  "text3738": "Billing and delivery details",
  "text3739": "Your order has been shipped",
  "text3740": "We registered your order under the number",
  "text3741": "we will deliver the order confirmation to the e-mail address entered when creating the order.",
  "text3742": "Back to main page",
  "text3743": "Searched products",
  "text3744": "items",
  "text3745": "Show all searches",
  "text3746": "Comparison of products",
  "text3747": "No products to compare. Add products by clicking the compare icon.",
  "text3748": "Weight",
  "text3749": "Color variants",
  "text3750": "Your account has been successfully created",
  "text3751": "Registration here",
  "text3752": "1 course = 5 training sessions",
  "text3753": "By subscribing to the newsletter, you agree to",
  "text3754": "Read our practical articles or get inspired by teak furniture trends.",
  "text3755": "View offer",
  "text3756": "Action products",
  "text3757": "Creating cargo type",
  "text3758": "Modification of cargo type",
  "text3759": "Delete cargo type",
  "text3760": "Creating load",
  "text3761": "Load adjustment",
  "text3762": "Deleting cargo",
  "text3763": "Creating reservation payment",
  "text3764": "Reservation payment modification",
  "text3765": "Deleting reservation payment",
  "text3766": "About accommodation",
  "text3767": "Your data is secure",
  "text3768": "Join more than",
  "text3769": "satisfied client",
  "text3770": "Verified and obtained by Google",
  "text3771": "Showroom opening hours",
  "text3772": "By purchasing this product, you will receive",
  "text3773": "points",
  "text3774": "You have on your account",
  "text3775": "Describe the product",
  "text3776": "(+) Positive",
  "text3777": "(-) Negative",
  "text3778": "Add positive",
  "text3779": "Add negative",
  "text3780": "The parent item cannot be this item or its child item.",
  "text3781": "The VAT number is invalid",
  "text3782": "The entered VAT number is invalid",
  "text3783": "You have {{param}} points",
  "text3784": "Reservation system",
  "text3785": "You can apply max.",
  "text3786": "Points redeemed",
  "text3787": "Studio rental",
  "text3788": "Number of points",
  "text3789": "Sale ended",
  "text3790": "We are currently preparing this product",
  "text3791": "I want a price offer",
  "text3792": "Price offer in 24hrs",
  "text3793": "Do you need a quote for your project? We will respond within 24 hours",
  "text3794": "Expert welding and metal fabrication at a professional level",
  "text3795": "Our team is ready to start your project immediately. Contact us today.",
  "text3796": "or call us",
  "text3797": "Fill out the inquiry form and we will contact you back as soon as possible to discuss your project in detail.",
  "text3798": "Our latest realizations",
  "text3799": "We operate throughout Europe",
  "text3800": "What can we offer our partners?",
  "text3801": "View job positions",
  "text3802": "What service are you interested in?",
  "text3803": "Select a service from the list",
  "text3804": "Desired delivery date",
  "text3805": "Project documentation",
  "text3806": "Attach a file",
  "text3807": "By sending a message, you agree to the processing of personal data for contact purposes.",
  "text3808": "We do not offer any vacancies at this moment.",
  "text3809": "No references were found in this category.",
  "text3810": "Delete the file",
  "text3811": "Based on the completed quote form, I will contact you as soon as possible with a quote proposal. Thank you for your patience.",
  "text3812": "I am interested in a job offer.",
  "text3813": "Used services",
  "text3814": "Step",
  "text3815": "We implement projects within the EU - mainly in Germany, Austria, the Czech Republic and Slovakia, but also in other countries according to the client's needs.",
  "text3816": "Get a quote for your project today!",
  "text3817": "Starting work",
  "text3818": "Employment type",
  "text3819": "Salary (gross)",
  "text3820": "About reference",
  "text3821": "Other realizations",
  "text3822": "Back to all blogs",
  "text3823": "More blogs",
  "text3824": "Content",
  "text3825": "Continue through",
  "text3826": "or",
  "text3827": "Login failed",
  "text3828": "For registration through a social account, consent to the processing of personal data is required.",
  "text3829": "Login was successful",
  "text3830": "The email from the social account is not verified.",
  "text3831": "The user account cannot be logged in.",
  "text3832": "Login via social account has expired.",
  "text3833": "Login via social account failed.",
  "text3834": "Search for medicines, vitamins, cosmetics...",
  "text3835": "Link copied to clipboard",
  "text3836": "Package number / tracking number...",
  "text3837": "Cancel here",
  "text3838": "You might also be interested.",
  "text3839": "More about category",
  "text3840": "Registered account",
  "text3841": "Return of goods - withdrawal from the contract",
  "text3842": "Repair of goods",
  "text3843": "",
  "text3844": "Filter products",
  "text3845": "Submission Summary",
  "text3846": "Acceptance",
  "text3847": "Termination",
  "text3848": "New complaint no.:",
  "text3849": "Secure purchase",
  "text3850": "Reset",
  "text3851": "Read full description",
  "text3852": "Package contents",
  "text3853": "For registration now you get:",
  "text3854": "Free offers",
  "text3855": "Free bid toppings",
  "text3856": "Courses for free",
  "text3857": "Free course toppings",
  "text3858": "Access to CVs for free",
  "text3859": "for your subscription",
  "text3860": "a fleet access code was created:",
  "text3861": "You can share this code with users to join your subscription.",
  "text3862": "Maximum number of members:",
  "text3863": "Fleet subscription code",
  "text3864": "An active subscription is required to submit another accident report.",
  "text3865": "Confirm withdrawal from contract",
  "text3866": "withdrawal from contract no.:",
  "text3867": "exchange of goods no.:",
  "text3868": "complaint no.:",
  "text3869": "exchange of goods",
  "text3870": "withdrawal from the contract",
  "text3871": "complaint",
  "text3872": "Over 1,750 genuine parts in stock",
  "text3873": "What part are you looking for?",
  "text3874": "Find the nearest store",
  "text3875": "Open catalog",
  "text3876": "Show all",
  "text3877": "Spare parts",
  "text3878": "Customer reviews",
  "text3879": "To add a product review,\nyou need to log in.",
  "text3880": "Discount code",
  "text3881": "Enter the code",
  "text3882": "Order summary",
  "text3883": "Proceed to Shipping and Payment",
  "text3884": "Continue to delivery details",
  "text3885": "Proceed to order summary",
  "text3886": "Order note",
  "text3887": "Order confirmed!",
  "text3888": "Thank you for your purchase.",
  "text3889": "We have sent the confirmation to",
  "text3890": "What comes next?",
  "text3891": "Order processed",
  "text3892": "Your payment was successful.",
  "text3893": "Preparing the package",
  "text3894": "The warehouse is preparing your order.",
  "text3895": "Handover to the carrier",
  "text3896": "The carrier will pick up the package for delivery.",
  "text3897": "Delivery",
  "text3898": "You will be contacted.",
  "text3899": "Opening hours",
  "text3900": "Dispatch and Warehouse",
  "text3901": "Carriers",
  "text3902": "Products in the collection",
  "text3903": "There are no products in this collection",
  "text3904": "Show more articles",
  "text3905": "Price calculator",
  "text3906": "I am interested in revision",
  "text3907": "I am interested in an offer",
  "text3908": "Order a free consultation",
  "text3909": "Send a request for quotation",
  "text3910": "View details",
  "text3911": "Show 5 more questions",
  "text3912": "Get started today",
  "text3913": "Get a non-binding quote for a sewage treatment plant",
  "text3914": "Would you rather call?",
  "text3915": "Mon to Fri, 8:00 a.m. to 5:00 p.m",
  "text3916": "I'm near a stream",
  "text3917": "How many people will use the treatment plant?",
  "text3918": "I have a sloping plot of land",
  "text3919": "Cost comparison",
  "text3920": "Why a root sewage treatment plant is worth more than a septic tank and an activation treatment plant",
  "text3921": "Annual operating costs",
  "text3922": "Total cost over 10 years",
  "text3923": "Worry-free operation",
  "text3924": "From order to launch",
  "text3925": "How is the installation of the waste water treatment plant",
  "text3926": "Mechanical pre-treatment in a septic tank",
  "text3927": "Biological cleaning with bacteria",
  "text3928": "Root filtration by plants",
  "text3929": "Natural process in 4 steps",
  "text3930": "How does a root sewage treatment plant work",
  "text3931": "Detailed guide",
  "text3932": "Waste water purifiers for family houses in Slovakia",
  "text3933": "Why choose ECOPLANET SLOVAKIA",
  "text3934": "Complete guide",
  "text3935": "Waste water purifier ECOKOCKA",
  "text3936": "on request",
  "text3937": "individual costing",
  "text3938": "Answers to your questions",
  "text3939": "Frequently asked questions about wastewater treatment plants",
  "text3940": "Your security",
  "text3941": "Why trust ECOPLANET SLOVAKIA",
  "text3942": "Practical information",
  "text3943": "What you should know before buying a sewage treatment plant",
  "text3944": "Real experiences",
  "text3945": "What our customers are saying",
  "text3946": "Google review",
  "text3947": "Scroll with arrows for more reviews",
  "text3948": "All of Slovakia",
  "text3949": "We install waste water purifiers all over Slovakia",
  "text3950": "households",
  "text3951": "all over Slovakia",
  "text3952": "municipalities and pensions",
  "text3953": "Most frequently asked questions",
  "text3954": "Page name",
  "text3955": "Contact persons",
  "text3956": "Contact address",
  "text3957": "Dates and prices",
  "text3958": "Tour description",
  "text3959": "Videos",
  "text3960": "Turnus",
  "text3961": "Number of days / nights",
  "text3962": "Reserved",
  "text3963": "Unknown status",
  "text3964": "Price includes",
  "text3965": "Price does not include",
  "text3966": "All tours",
  "text3967": "Book an appointment",
  "text3968": "Booking a meeting",
  "text3969": "Subscribe to the newsletter",
  "text3970": "Be the first to know about poops, dates and discounts.",
  "text3971": "By submitting, you agree to the processing of personal data.",
  "text3972": "Overview of terms",
  "text3973": "See the program",
  "text3974": "Similar tours",
  "text3975": "Done",
  "text3976": "All dates have already taken place",
  "text3977": "Read articles about Madeira!",
  "text3978": "Book without obligation",
  "text3979": "Non-binding tour reservation",
  "text3980": "Non-binding reservation",
  "text3981": "Enter your phone number. number",
  "text3982": "Add another participant",
  "text3983": "Delete participant",
  "text3984": "Encounter type",
  "text3985": "Meeting City",
  "text3986": "Date and time",
  "text3987": "Next",
  "text3988": "Sending...",
  "text3989": "Confirm the reservation",
  "text3990": "Select a meeting place",
  "text3991": "Meeting place",
  "text3992": "Subscribe to the newsletter and always receive the most up-to-date information from our offer.",
  "text3993": "Where can you find us?",
  "text3994": "What makes our travel agency DISCOVER THE WORLD special?",
  "text3995": "Office (operation)",
  "text3996": "INFORMATIKA building on the 2nd floor",
  "text3997": "Thank you for your reservation!...",
  "text3998": "Nearest tours",
  "text3999": "Enter your contact details and expected budget.",
  "text4000": "Requesting as",
  "text4001": "6,000 and more",
  "text4002": "What should we prepare for you?",
  "text4003": "Your request was submitted",
  "text4004": "Thank you. We will send the prepared price quote to your e-mail.",
  "text4005": "Request number",
  "text4006": "Submit another request",
  "text4007": "The maximum budget must be greater than the minimum budget.",
  "text4008": "Check the highlighted fields.",
  "text4009": "Too many requests were submitted. Please try again later.",
  "text4010": "Review the prepared quote and decide whether to accept it.",
  "text4011": "The price quote is being prepared.",
  "text4012": "The price quote is not final yet.",
  "text4013": "You have opened the quote. You can accept or reject it.",
  "text4014": "You have accepted this price quote.",
  "text4015": "You have rejected this price quote.",
  "text4016": "This price quote has expired.",
  "text4017": "The price quote has been converted into an order.",
  "text4018": "Valid until",
  "text4019": "No expiry date",
  "text4020": "Quote items",
  "text4021": "Products total",
  "text4022": "Quote note",
  "text4023": "Accept quote",
  "text4024": "Reject quote",
  "text4025": "Accept the price quote?",
  "text4026": "By confirming, you will let the seller know that you agree with the price quote.",
  "text4027": "Reject the price quote?",
  "text4028": "By confirming, you will let the seller know that you do not accept the price quote.",
  "text4029": "Yes, accept",
  "text4030": "Yes, reject",
  "text4031": "A decision can no longer be made for this price quote.",
  "text4032": "The decision could not be saved. Refresh the page and try again.",
  "text4033": "The document could not be downloaded. Please try again.",
  "text4034": "Price quote not found",
  "text4035": "The link is invalid, the quote has not been sent yet, or it is no longer available.",
  "text4036": "The price quote could not be loaded",
  "text4037": "Refresh the page or contact the seller.",
  "text4038": "Create a new request",
  "text4039": "The quote does not contain any items.",
  "text4040": "View product",
  "text4041": "Draft",
  "text4042": "Sent",
  "text4043": "Viewed",
  "text4044": "Accepted",
  "text4045": "Expired",
  "text4046": "Converted to order",
  "text4047": "Clear the cart?",
  "text4048": "Are you sure you want to remove all items from your cart? This action cannot be undone.",
  "text4049": "Yes, clear cart",
  "text4050": "Please provide a price range, as this affects the pricing.",
  "text4051": "Price range",
  "text4052": "Are these your company details?",
  "text4053": "Unit price incl. VAT",
  "text4054": "Remove coupon",
  "text4055": "Inactive",
  "text4056": "Insured",
  "text4057": "Uninsured",
  "text4058": "Add vehicle",
  "text4059": "Edit vehicle",
  "text4060": "Delete vehicle?",
  "text4061": "My garage",
  "text4062": "Technical and emissions inspection date",
  "text4063": "Export failed. Please try again.",
  "text4064": "Pause video",
  "text4065": "Material",
  "text4066": "New configuration",
  "text4067": "Configuration steps",
  "text4068": "Upload a file",
  "text4069": "Book an appointment",
  "text4070": "Failed to copy link",
  "text4071": "Data updated successfully",
  "text4072": "Add to comparison",
  "text4073": "Remove from comparison",
  "text4074": "Back to list",
  "text4075": "Region",
  "text4076": "Catalogues",
  "text4077": "My fleet",
  "text4078": "Damage overview",
  "text4079": "Registration number",
  "text4080": "Departure date and time",
  "text4081": "Arrival date and time",
  "text4082": "Ticket number",
  "text4083": "Passport number",
  "text4084": "Back to parameters",
  "text4085": "Summary & contact",
  "text4086": "Configuration was sent",
  "text4087": "Lowest salary",
  "text4088": "Highest salary",
  "text4089": "Configuration summary",
  "text4090": "Updated:",
  "text4091": "Contact email *",
  "text4092": "Loading configurations...",
  "text4093": "Apply code",
  "text4094": "Note (optional)...",
  "text4095": "Draft configurations",
  "text4096": "No products are available here yet",
  "text4097": "Failed to load configuration",
  "text4098": "Failed to send configuration",
  "text4099": "Failed to open configuration",
  "text4100": "Failed to save configuration",
  "text4101": "Load from registry",
  "text4102": "Estimated price",
  "text4103": "Sent",
  "text4104": "Sent price quotes",
  "text4105": "We'll send the price quote by email",
  "text4106": "for the purpose of issuing a price quote in accordance with GDPR.",
  "text4107": "Ask a question about the product",
  "text4108": "",
  "text4109": "",
  "text4110": "",
  "text4111": "",
  "text4112": "",
  "text4113": "",
  "text4114": "",
  "text4115": "",
  "text4116": "",
  "text4117": "",
  "text4118": "",
  "text4119": "",
  "text4120": "",
  "text4121": "",
  "text4122": "",
  "text4123": "",
  "text4124": "",
  "text4125": "",
  "text4126": "",
  "text4127": "",
  "text4128": "",
  "text4129": "",
  "text4130": "",
  "text4131": "",
  "text4132": "",
  "text4133": "",
  "text4134": "",
  "text4135": "",
  "text4136": "",
  "text4137": "",
  "text4138": "",
  "text4139": "",
  "text4140": "",
  "text4141": "",
  "text4142": "",
  "text4143": "",
  "text4144": "",
  "text4145": "",
  "text4146": "",
  "text4147": "",
  "text4148": "",
  "text4149": "",
  "text4150": "",
  "coupon_offer_without_vat": "excluding VAT",
  "coupon_offer_with_code": "with discount code",
  "coupon_offer_validity": "Valid for (hours:minutes:seconds):",
  "coupon_offer_minimum": "Minimum cart merchandise total including VAT:",
  "coupon_offer_cart_hint": "Enter the code in the cart. Validity and conditions are checked when applied.",
  "coupon_offer_fixed_hint": "The fixed discount is shared across eligible cart items.",
  "Price for one unit with code (including VAT):": "Price for one unit with code (including VAT):",
  "Price before coupon (including VAT):": "Price before coupon (including VAT):"
}) satisfies TranslationDictionary;
